export const helpArticles = [
  // ─── Başlangıç ────────────────────────────────────────────────────────────
  {
    id: 'system-login',
    category: 'Başlangıç',
    title: 'Sisteme Giriş',
    summary: 'Beneksus\'a ilk kez veya her yeni oturumda nasıl giriş yapılacağını anlatan adım adım kılavuz.',
    tags: ['giriş', 'login', 'şifre', 'hesap', 'oturum'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Tarayıcınızda Beneksus adresini açın.', imageUrl: null},
      {order: 2, text: 'Giriş ekranında "Giriş Yap" butonuna tıklayın.', imageUrl: '/images/help/system-login-step-2.png'},
      {order: 3, text: 'Kurumsal e-posta adresinizi, şifrenizi girin ve "Oturum Aç" butonuna tıklayın.', imageUrl: '/images/help/system-login-step-3.png'},      
      {order: 4, text: 'Giriş başarılı olduğunda sizi otomatik olarak ana sayfaya (dashboard) yönlendirir.', imageUrl: null},
    ],
    notes: [
      'Beneksus, şirketinizin kurumsal hesabıyla bağlantılıdır. Kişisel e-posta adresleri ile giriş yapılamaz; yalnızca yöneticiniz tarafından sisteme tanımlanan kurumsal hesabınızı kullanın.',
      'Şifrenizi unuttunuz? Giriş ekranındaki "Şifremi Unuttum" bağlantısına tıklayın. Kayıtlı e-posta adresinize şifre sıfırlama bağlantısı gönderilir.',
    ],
  },
  {
    id: 'first-login-tour',
    category: 'Başlangıç',
    title: 'İlk Giriş Turu',
    summary: 'Sisteme ilk kez giriş yapan kullanıcılar için ana menü, dashboard ve temel modüllere genel bakış.',
    tags: ['başlangıç', 'menü', 'dashboard', 'modül', 'genel bakış'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Giriş yaptıktan sonra karşınıza Dashboard (Ana Sayfa) gelir. Burada projelere ait özet bilgiler, görevler ve bildirimler görüntülenir.', imageUrl: '/images/help/first-login-tour-step-1.png'},
      {order: 2, text: 'Ekranın solundaki kenar menüsünden tüm modüllere ulaşabilirsiniz. Menü simgesine tıklayarak menüyü genişletip daraltabilirsiniz.', imageUrl: '/images/help/first-login-tour-step-2.png'},
      {order: 3, text: 'Üst menü çubuğundaki arama ikonu ile sistem genelinde hızlı arama yapabilirsiniz.', imageUrl: '/images/help/first-login-tour-step-3.png'},
      {order: 4, text: 'Üst menüdeki zil ikonu bildirimleri gösterir. Bekleyen onaylar ve size atanan görevler burada listelenir.', imageUrl: '/images/help/first-login-tour-step-4.png'},
      {order: 5, text: 'Üst menüdeki soru işareti ikonu sizi bu Yardım Merkezi sayfasına yönlendirir.', imageUrl: null},
      {order: 6, text: 'Sol alt köşedeki profil alanına tıklayarak hesap ayarlarınıza ulaşabilir veya oturumu kapatabilirsiniz.', imageUrl: '/images/help/first-login-tour-step-6.png'},
    ],
    notes: [
      'Sol menüde yalnızca rolünüze tanımlı modüller görünür. Erişemediğiniz bir modül için yöneticinizle iletişime geçin.',
    ],
  },
  {
    id: 'profile-settings',
    category: 'Başlangıç',
    title: 'Profil ve Şifre Ayarları',
    summary: 'Ad, iletişim bilgileri gibi profil bilgilerini güncelleme ve şifre değiştirme adımları.',
    tags: ['profil', 'şifre', 'hesap', 'güncelleme', 'ayarlar'],
    thumbnailUrl: null,
    steps: [
      { order: 1, text: 'Sol alt köşedeki profil alanınıza tıklayın.', imageUrl: '/images/help/profile-settings-step-1.png' },
      {order: 2, text: 'Açılan menüden "Profilim" veya "Hesap Ayarları" seçeneğini seçin.', imageUrl: null},
      {order: 3, text: 'Ad, soyad ve iletişim bilgilerinizi düzenleyerek "Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Beneksus kurumsal kimlik doğrulama sistemi (Azure AD) üzerinden çalıştığı için şifre değişikliği doğrudan uygulama içinden yapılamamaktadır. Şifrenizi değiştirmek için yöneticinizle veya IT departmanıyla iletişime geçin.',
    ],
  },

  // ─── Mobil ────────────────────────────────────────────────────────────────
  {
    id: 'mobile-add-to-homescreen-android',
    category: 'Mobil',
    title: 'Android\'de Ana Ekrana Ekleme',
    summary: 'Beneksus\'u Android cihazınızda uygulama gibi kullanmak için Chrome tarayıcısı üzerinden ana ekrana kısayol ekleme adımları.',
    tags: ['android', 'ana ekran', 'mobil', 'chrome', 'kısayol'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Android cihazınızda Chrome tarayıcısını açın.', imageUrl: null},
      { order: 2, text: 'Adres çubuğuna Beneksus adresini yazıp sisteme giriş yapın.', imageUrl: null},
      { order: 3, text: 'Sağ üst köşedeki üç nokta (⋮) menüsüne dokunun.', imageUrl: 'images/help/mobile-add-to-homescreen-android-step-3.png' },
      { order: 4, text: 'Açılan menüden "Ana ekrana ekle" seçeneğine dokunun.', imageUrl: 'images/help/mobile-add-to-homescreen-android-step-4.png' },
      {order: 5, text: 'Gelen iletişim kutusunda uygulama adını göreceksiniz. "Ekle" butonuna dokunun.', imageUrl: null},
      {order: 6, text: 'Ana ekranda Beneksus ikonu oluşacak. Bu ikona dokunarak sistemi doğrudan açabilirsiniz.', imageUrl: null},
    ],
    notes: [
      'Samsung Internet kullanıcıları için: Chrome yerine Samsung Internet tarayıcısı kullanıyorsanız alt menüdeki hamburger (☰) ikonuna dokunun → "Sayfayı ekle" → "Ana ekran" seçin → "Ekle" butonuna dokunun.',
    ],
  },
  {
    id: 'mobile-add-to-homescreen-ios',
    category: 'Mobil',
    title: 'iPhone/iPad\'de Ana Ekrana Ekleme',
    summary: 'Beneksus\'u iPhone veya iPad\'inizde uygulama gibi kullanmak için Safari tarayıcısı üzerinden ana ekrana kısayol ekleme adımları.',
    tags: ['ios', 'iphone', 'ipad', 'apple', 'safari', 'ana ekran', 'kısayol'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'iPhone veya iPad\'inizde Safari tarayıcısını açın.', imageUrl: null},
      {order: 2, text: 'Adres çubuğuna Beneksus adresini yazıp sisteme giriş yapın.', imageUrl: null},
      { order: 3, text: 'Ekranın alt kısmındaki paylaş ikonuna (kare içinde yukarı ok) dokunun.', imageUrl: 'images/help/mobile-add-to-homescreen-ios-step-3.png'},
      { order: 4, text: 'Açılan menüyü aşağı kaydırarak "Ana Ekrana Ekle" seçeneğine dokunun.', imageUrl: 'images/help/mobile-add-to-homescreen-ios-step-4.png' },
      { order: 5, text: 'Uygulama adını istediğiniz gibi düzenleyebilirsiniz. Sağ üst köşedeki "Ekle" butonuna dokunun.', imageUrl: 'images/help/mobile-add-to-homescreen-ios-step-5.png' },
      {order: 6, text: 'Ana ekranda Beneksus ikonu oluşacak. Bu ikona dokunarak sistemi doğrudan açabilirsiniz.', imageUrl: null},
    ],
    notes: [
      'Bu işlem yalnızca Safari tarayıcısında çalışır. iOS\'ta Chrome veya başka bir tarayıcı kullanıyorsanız "Ana Ekrana Ekle" seçeneği görünmez; Safari\'ye geçmeniz gerekir.',
    ],
  },
  {
    id: 'mobile-login',
    category: 'Mobil',
    title: 'Mobil Cihazdan Giriş',
    summary: 'Telefon veya tablet üzerinden Beneksus\'a giriş yapma ve oturumu açık tutma adımları.',
    tags: ['mobil', 'giriş', 'telefon', 'tablet', 'oturum'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Mobil cihazınızda tarayıcıyı açın (Android için Chrome, iPhone/iPad için Safari önerilir).', imageUrl: null},
      {order: 2, text: 'Beneksus adresini adres çubuğuna yazın veya daha önce ana ekrana eklediğiniz ikona dokunun.', imageUrl: null},
      {order: 3, text: 'Giriş ekranında "Giriş Yap" butonuna dokunun.', imageUrl: null},
      {order: 4, text: 'Kurumsal e-posta adresinizi girin, "İleri" butonuna dokunun.', imageUrl: null},
      {order: 5, text: 'Şifrenizi girin ve "Giriş Yap" butonuna dokunun.', imageUrl: null},
      {order: 6, text: 'Başarılı girişin ardından dashboard ekranı açılır.', imageUrl: null},
    ],
    notes: [
      'Oturumu açık tutmak için: Giriş sırasında "Oturumu açık tut" veya "Beni hatırla" seçeneğini işaretleyin.',
      'Şirket cihazı dışında kişisel bir cihaz kullanıyorsanız oturumu kapatmayı unutmayın. Sağ üst köşedeki profil alanından "Çıkış Yap" seçeneğini kullanın.',
    ],
  },
  {
    id: 'mobile-photo-upload',
    category: 'Mobil',
    title: 'Mobil Cihazdan Fotoğraf Yükleme',
    summary: 'Şantiyede çekilen fotoğrafları mobil cihaz üzerinden projeye veya göreve ekleme adımları.',
    tags: ['fotoğraf', 'yükleme', 'mobil', 'dosya', 'proje', 'görev', 'şantiye'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sisteme giriş yapın ve fotoğraf eklemek istediğiniz proje veya göreve gidin.', imageUrl: null},
      {order: 2, text: 'İlgili kayıt içinde "Dosyalar" veya "Ekler" sekmesine dokunun.', imageUrl: null},
      {order: 3, text: '"Dosya Ekle" veya "Yükle" butonuna dokunun.', imageUrl: '/images/help/mobile-photo-upload-step-3.png'},
      {order: 4, text: 'Açılan seçeneklerden "Fotoğraf Çek" (anında çekmek için) veya "Galeriden Seç" (mevcut fotoğraf için) seçeneğini seçin.', imageUrl: '/images/help/mobile-photo-upload-step-4.png'},
      {order: 5, text: 'Fotoğrafı çekin veya galeriden seçin.', imageUrl: null},
      {order: 6, text: 'Gerekiyorsa fotoğrafa açıklama ekleyin, ardından "Yükle" veya "Kaydet" butonuna dokunun.', imageUrl: null},
      {order: 7, text: 'Yükleme tamamlandığında fotoğraf dosyalar listesinde görünür.', imageUrl: null},
    ],
    notes: [
      'Yükleme sırasında internet bağlantınızın stabil olduğundan emin olun. Büyük fotoğraflar Wi-Fi bağlantısıyla daha hızlı yüklenir.',
      'Birden fazla fotoğraf yüklemek için yükleme adımını tekrarlayabilirsiniz.',
    ],
  },
  {
    id: 'mobile-video-upload',
    category: 'Mobil',
    title: 'Mobil Cihazdan Video Yükleme',
    summary: 'Şantiyede kaydedilen videoları mobil cihaz üzerinden projeye veya göreve ekleme adımları.',
    tags: ['video', 'yükleme', 'mobil', 'dosya', 'proje', 'görev', 'şantiye'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sisteme giriş yapın ve video eklemek istediğiniz proje veya göreve gidin.', imageUrl: null},
      {order: 2, text: 'İlgili kayıt içinde "Dosyalar" veya "Ekler" sekmesine dokunun.', imageUrl: null},
      {order: 3, text: '"Dosya Ekle" veya "Yükle" butonuna dokunun.', imageUrl: null},
      {order: 4, text: 'Açılan seçeneklerden "Video Çek" (anında kaydetmek için) veya "Galeriden Seç" (mevcut video için) seçeneğini seçin.', imageUrl: null},
      {order: 5, text: 'Videoyu kaydedin veya galeriden seçin.', imageUrl: null},
      {order: 6, text: 'Gerekiyorsa açıklama ekleyin, ardından "Yükle" veya "Kaydet" butonuna dokunun.', imageUrl: null},
      {order: 7, text: 'Yükleme tamamlandığında video dosyalar listesinde görünür.', imageUrl: null},
    ],
    notes: [
      'Videolar fotoğraflara kıyasla çok daha büyük dosya boyutuna sahip olabilir. Yükleme süresi uzayabilir; bu sürede uygulamayı kapatmayın.',
      'Uzun videoları yüklemeden önce Wi-Fi bağlantısına geçmeniz önerilir.',
    ],
  },
  {
    id: 'mobile-note-add',
    category: 'Mobil',
    title: 'Mobil Cihazdan Not Ekleme',
    summary: 'Görev veya projeye mobil cihaz üzerinden not bırakma adımları.',
    tags: ['not', 'yorum', 'mobil', 'görev', 'proje', 'açıklama'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sisteme giriş yapın ve not eklemek istediğiniz proje veya göreve gidin.', imageUrl: null},
      {order: 2, text: 'İlgili kayıt içinde "Notlar" veya "Yorumlar" sekmesine dokunun.', imageUrl: null},
      {order: 3, text: '"Not Ekle" butonuna dokunun.', imageUrl: null},
      { order: 4, text: 'Açılan metin alanına notunuzu yazın.', imageUrl: '/images/help/mobile-note-add-step-4.png' },
      { order: 5, text: 'Ataç ikonuna tıklayarak nota resim ekleyebilirsiniz.', imageUrl: '/images/help/mobile-note-add-step-5.png' },
      {order: 6, text: '"Kaydet" butonuna dokunun.', imageUrl: null},
      {order: 7, text: 'Notunuz, kaydın altında tarih ve kullanıcı adıyla birlikte listelenir.', imageUrl: null},
    ],
    notes: [
      'Notlar ilgili kayıtta kalıcı olarak saklanır ve diğer yetkili kullanıcılar tarafından da görüntülenebilir. Hassas bilgileri not olarak bırakmaktan kaçının.',
    ],
  },

  // ─── İş Takibi ────────────────────────────────────────────────────────────
  {
    id: 'task-create',
    category: 'İş Takibi',
    title: 'Yeni Görev Oluşturma',
    summary: 'İş programında yeni bir görev açma ve kaydetme adımları.',
    tags: ['görev', 'iş', 'program', 'oluşturma', 'takip'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "İş Takibi" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Görev" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Görev başlığını girin.', imageUrl: null},
      {order: 4, text: 'Görev durumunu listeden seçin (ör. Planlandı, Devam Ediyor).', imageUrl: null},
      {order: 5, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 6, text: 'İnşaat alanını seçin.', imageUrl: null},
      {order: 7, text: 'Bloğu seçin.', imageUrl: null},
      {order: 8, text: 'İsterseniz sorumlu kişi, başlangıç/bitiş tarihi ve açıklama ekleyin.', imageUrl: null},
      {order: 9, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Başlık, görev durumu, proje, inşaat alanı ve blok zorunlu alanlardır; bunlar doldurulmadan görev kaydedilemez.',
      'Sorumlu kişi ve tarih alanları zorunlu olmamakla birlikte, görev takibinin sağlıklı yürüyebilmesi için doldurulması önerilir.',
    ],
  },
  {
    id: 'task-subtask-add',
    category: 'İş Takibi',
    title: 'Alt Görev Ekleme',
    summary: 'İş programındaki mevcut bir göreve bağlı alt görev oluşturma adımları.',
    tags: ['görev', 'alt görev', 'iş programı', 'workplan', 'oluşturma'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "İş Takibi" modülüne gidin ve alt görev eklemek istediğiniz göreve tıklayın.', imageUrl: null},
      {order: 2, text: 'Görev detay sayfasında "Alt Görevler" sekmesine tıklayın.', imageUrl: null},
      {order: 3, text: '"Alt Görev Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 4, text: 'Alt görevin adını girin.', imageUrl: null},
      {order: 5, text: 'Görev durumunu seçin (Başlanacak, Devam Etmekte, Tamamlandı).', imageUrl: null},
      {order: 6, text: 'İsterseniz personel, başlangıç/bitiş tarihi, süre, toplam iş ve tamamlanma oranı bilgilerini girin.', imageUrl: null},
      {order: 7, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Alt görev adı ve görev durumu zorunludur. Proje, inşaat alanı ve blok bilgileri üst görevden otomatik devralınır.',
      'Alt görevin tamamlanma oranı değiştikçe üst görevin tamamlanma oranı da otomatik olarak yeniden hesaplanır.',
    ],
  },
  {
    id: 'task-product-add',
    category: 'İş Takibi',
    title: 'Kullanılan Malzeme Ekleme',
    summary: 'İş programındaki bir göreve kullanılan malzeme veya ürünleri kaydetme adımları.',
    tags: ['malzeme', 'ürün', 'görev', 'iş programı', 'miktar', 'stok'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "İş Takibi" modülüne gidin ve malzeme eklemek istediğiniz göreve tıklayın.', imageUrl: null},
      {order: 2, text: 'Görev detay sayfasında "Ürünler" veya "Malzemeler" sekmesine tıklayın.', imageUrl: null},
      {order: 3, text: '"Yeni Satır Ekle" butonuna tıklayın; forma yeni bir satır eklenir.', imageUrl: null},
      {order: 4, text: 'Açılan satırda ürünü listeden seçin.', imageUrl: null},
      {order: 5, text: 'Miktarı girin.', imageUrl: null},
      {order: 6, text: 'İsterseniz ürün birimini ve açıklamayı girin.', imageUrl: null},
      {order: 7, text: 'Birden fazla malzeme eklemek istiyorsanız 3-6. adımları tekrarlayın.', imageUrl: null},
      {order: 8, text: 'Tüm satırlar doldurulunca "Gönder" veya "Kaydet" butonuna tıklayın. Tüm satırlar aynı anda kaydedilir.', imageUrl: null},
    ],
    notes: [
      'Her satırda ürün seçimi ve miktar zorunludur. Miktar sıfır veya negatif girilemez.',
      'Mevcut bir malzeme kaydını silmek için satırın sonundaki silme (çöp kutusu) ikonuna tıklayın.',
    ],
  },
  {
    id: 'task-completion-update',
    category: 'İş Takibi',
    title: 'Tamamlanma Oranı Güncelleme',
    summary: 'İş programındaki bir görevin durum ve tamamlanma yüzdesini güncelleme adımları.',
    tags: ['tamamlanma', 'oran', 'durum', 'görev', 'güncelleme', 'yüzde'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "İş Takibi" modülüne gidin ve güncellemek istediğiniz göreve tıklayın.', imageUrl: null},
      {order: 2, text: 'Görev detay sayfasının sağ tarafında tamamlanma güncelleme formunu bulun.', imageUrl: null},
      {order: 3, text: 'Görev durumunu seçin (Başlanacak, Devam Etmekte, Tamamlandı).', imageUrl: null},
      {order: 4, text: 'Tamamlanma oranını yüzde olarak girin (0-100 arası).', imageUrl: null},
      {order: 5, text: 'İsterseniz bitiş tarihini girin.', imageUrl: null},
      {order: 6, text: '"Güncelle" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Görev durumu zorunludur. Durum "Tamamlandı" seçildiğinde tamamlanma oranı otomatik olarak %100 ayarlanır.',
      'Bir görevin tamamlanma oranı güncellendiğinde, bağlı olduğu üst görevin oranı da otomatik olarak yeniden hesaplanır.',
    ],
  },
  {
    id: 'activity-report-create',
    category: 'İş Takibi',
    title: 'Faaliyet Raporu Oluşturma',
    summary: 'Günlük faaliyet raporunu sisteme girme adımları.',
    tags: ['faaliyet', 'rapor', 'günlük', 'giriş', 'iş takibi', 'parsel'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Faaliyet Raporları" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Rapor" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 4, text: 'Faaliyet türünü seçin.', imageUrl: null},
      {order: 5, text: 'Rapor tarihini girin.', imageUrl: null},
      {order: 6, text: 'Faaliyet durumunu seçin.', imageUrl: null},
      {order: 7, text: 'Faaliyet çalışmaları bölümünde parseli seçin ve yapılan işleri girin.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Proje, faaliyet türü, tarih, durum ve parsel zorunlu alanlardır; bunlar doldurulmadan rapor kaydedilemez.',
      'Faaliyet raporlarını günlük olarak düzenli girmek, proje ilerleme takibinin doğru çalışmasını sağlar.',
    ],
  },
  {
    id: 'calendar-view',
    category: 'İş Takibi',
    title: 'Takvim Kullanımı',
    summary: 'İş takvimi üzerinden görev ve etkinlikleri görüntüleme, tarihe göre planlama yapma adımları.',
    tags: ['takvim', 'planlama', 'görev', 'etkinlik', 'tarih', 'program'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Takvim" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Takvim; günlük, haftalık ve aylık görünüm seçenekleri sunar. Sağ üst köşeden görünüm tipini değiştirebilirsiniz.', imageUrl: null},
      {order: 3, text: 'Bir güne tıklayarak o tarihte planlanan görev ve etkinlikleri görebilirsiniz.', imageUrl: null},
      {order: 4, text: 'Takvim üzerinde bir tarih aralığı seçerek yeni bir etkinlik veya görev ekleyebilirsiniz.', imageUrl: null},
      {order: 5, text: 'Mevcut bir etkinliğe tıklayarak detaylarını görüntüleyebilir veya düzenleyebilirsiniz.', imageUrl: null},
    ],
    notes: [
      'Takvimi proje bazında filtreleyin; böylece yalnızca belirli bir projeye ait görev ve etkinlikler görüntülenir.',
    ],
  },

  // ─── Finans ───────────────────────────────────────────────────────────────
  {
    id: 'expense-entry',
    category: 'Finans',
    title: 'Gider Girişi',
    summary: 'Gider faturası kaydı oluşturma adımları.',
    tags: ['gider', 'fatura', 'finans', 'muhasebe', 'kalem', 'kayıt'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Giderler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Gider" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Gider adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Fatura türünü seçin.', imageUrl: null},
      {order: 6, text: 'Gider kalemleri bölümünde "+ Kalem Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 7, text: 'Her kalem için ürünü, miktarı, birim fiyatı, ürün birimini ve vergi oranını girin.', imageUrl: null},
      {order: 8, text: 'Birden fazla kalem varsa 6-7. adımları tekrarlayın.', imageUrl: null},
      {order: 9, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Gider adı, proje, fatura türü ve en az bir gider kalemi zorunludur.',
      'Ödeme yapıldıysa kayıt sırasında ödeme durumunu güncelleyin; bu durumda hesap, ciro adı ve ödeme tarihi alanları da zorunlu hale gelir.',
    ],
  },
  {
    id: 'expense-payment-add',
    category: 'Finans',
    title: 'Gidere Ödeme Ekleme',
    summary: 'Gider kaydına nakit, mevcut çek, yeni çek veya avans çeki ile ödeme ekleme adımları.',
    tags: ['gider', 'ödeme', 'nakit', 'çek', 'avans', 'finans', 'bakiye'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Giderler" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Ödeme eklemek istediğiniz gider kaydına tıklayın.', imageUrl: null},
      {order: 3, text: 'Gider detay sayfasında "Ödeme Ekle" kartını bulun. Kart yalnızca ödenmemiş bakiye varsa görünür.', imageUrl: null},
      {order: 4, text: 'Ödeme türü sekmelerinden birini seçin: Nakit, Mevcut Çek, Yeni Çek veya Avans Çeki.', imageUrl: null},
      {order: 5, text: 'Seçtiğiniz ödeme türüne ait alanları doldurun (tarih, hesap, tutar vb.).', imageUrl: null},
      {order: 6, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Ödeme eklendikten sonra giderin bakiyesi otomatik olarak güncellenir. Tüm bakiye kapatılırsa gider "Ödendi" durumuna geçer.',
      'Bakiye sıfırlanmış giderlere ödeme eklenemez.',
    ],
  },
  {
    id: 'payment-request',
    category: 'Finans',
    title: 'Ödeme Talebi Oluşturma',
    summary: 'Onay akışı gerektiren ödeme taleplerini sisteme girme ve onaya gönderme adımları.',
    tags: ['ödeme', 'talep', 'onay', 'finans', 'iban', 'akış'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Ödeme Talepleri" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Talep" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 4, text: 'Talebin adını girin.', imageUrl: null},
      {order: 5, text: 'Ödeme talep türünü seçin.', imageUrl: null},
      {order: 6, text: 'Ödeme yapılacak firmanın şirket unvanını girin.', imageUrl: null},
      {order: 7, text: 'Şirket bakiyesini girin.', imageUrl: null},
      {order: 8, text: 'IBAN numarasını girin.', imageUrl: null},
      {order: 9, text: 'Talep edilen tutarı girin.', imageUrl: null},
      {order: 10, text: 'Talep tarihini seçin.', imageUrl: null},
      {order: 11, text: 'Varsa destekleyici belgeleri sisteme yükleyin.', imageUrl: null},
      {order: 12, text: '"Kaydet" butonuna tıklayın. Talep onay akışına iletilir.', imageUrl: null},
    ],
    notes: [
      'Proje, talep adı, tür, şirket unvanı, bakiye, IBAN, tutar ve tarih alanlarının tamamı zorunludur.',
      'Onaya gönderilen taleplerde değişiklik yapmak için talebin geri çekilmesi gerekebilir. Talebinizin durumu değiştiğinde sistem size bildirim gönderir.',
    ],
  },
  {
    id: 'invoice-create',
    category: 'Finans',
    title: 'Satış Faturası Oluşturma',
    summary: 'Müşteriye kesilecek satış faturasını sisteme girme ve oluşturma adımları.',
    tags: ['fatura', 'satış', 'müşteri', 'finans', 'muhasebe', 'e-fatura', 'kalem'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Satış Faturaları" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Fatura" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Fatura adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Fatura türünü seçin.', imageUrl: null},
      {order: 6, text: 'Fatura kalemleri bölümünde "+ Kalem Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 7, text: 'Her kalem için ürünü, miktarı, birim fiyatı, ürün birimini ve vergi oranını girin.', imageUrl: null},
      {order: 8, text: 'Birden fazla kalem varsa 6-7. adımları tekrarlayın.', imageUrl: null},
      {order: 9, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Fatura adı, proje, fatura türü ve en az bir fatura kalemi zorunludur.',
      'E-Fatura kullanıcıları için: Müşteri e-fatura mükellefi ise fatura kaydedildikten sonra "E-Fatura Gönder" butonu aktif hale gelir.',
      'Kaydedilen ve gönderilen faturalar üzerinde değişiklik yapılamaz.',
    ],
  },

  // ─── Yönetim ──────────────────────────────────────────────────────────────
  {
    id: 'user-create',
    category: 'Yönetim',
    title: 'Kullanıcı Oluşturma',
    summary: 'Sisteme yeni bir personel hesabı ekleme ve rol atama adımları.',
    tags: ['kullanıcı', 'personel', 'hesap', 'rol', 'yönetim', 'ekleme'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Yönetim" veya "Kullanıcılar" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Kullanıcı" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Personelin ad, soyad ve kurumsal e-posta adresini girin.', imageUrl: null},
      {order: 4, text: 'Kullanıcıya atanacak rolü seçin (ör. Yönetici, Saha Personeli, Muhasebe).', imageUrl: null},
      {order: 5, text: 'Gerekiyorsa kullanıcının erişebileceği projeleri belirleyin.', imageUrl: null},
      {order: 6, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
      {order: 7, text: 'Kullanıcıya sisteme giriş için otomatik davet e-postası gönderilir.', imageUrl: null},
    ],
    notes: [
      'Ad, soyad ve e-posta zorunlu alanlardır. Rol atanmayan kullanıcı sisteme giriş yapamayabilir veya herhangi bir modülü göremeyebilir.',
      'Sistemden ayrılan personelin hesabını silmek yerine pasif konuma getirin. Böylece geçmiş veriler ve işlem kayıtları korunmuş olur.',
    ],
  },
  {
    id: 'category-management',
    category: 'Yönetim',
    title: 'Kategori Yönetimi',
    summary: 'Sistemde kullanılan genel kategorileri görüntüleme, düzenleme ve yeni kategori ekleme adımları.',
    tags: ['kategori', 'yönetim', 'ayarlar', 'liste', 'düzenleme'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Yönetim" veya "Ayarlar" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Kategoriler" seçeneğine tıklayın.', imageUrl: null},
      {order: 3, text: 'Mevcut kategorilerin listesi görüntülenir.', imageUrl: null},
      {order: 4, text: 'Yeni kategori eklemek için "+ Ekle" butonuna tıklayın, kategori adını girin ve "Kaydet" butonuna tıklayın.', imageUrl: null},
      {order: 5, text: 'Mevcut bir kategoriyi düzenlemek için ilgili satırdaki düzenle (kalem) ikonuna tıklayın, değişikliği yapın ve "Kaydet" butonuna tıklayın.', imageUrl: null},
      {order: 6, text: 'Kullanılmayan bir kategoriyi kaldırmak için sil ikonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Sistemde aktif olarak kullanılan bir kategori silinirse ilgili kayıtlarda kategori bilgisi boş kalabilir. Silmeden önce kategorinin kullanımda olup olmadığını kontrol edin.',
    ],
  },

  // ─── Proje Yönetimi ───────────────────────────────────────────────────────
  {
    id: 'project-create',
    category: 'Proje Yönetimi',
    title: 'Yeni Proje Oluşturma',
    summary: 'Sistemde yeni bir inşaat projesi kaydı açma ve temel bilgileri girme adımları.',
    tags: ['proje', 'oluşturma', 'yeni', 'kayıt', 'inşaat'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Projeler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Proje" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Proje adını girin.', imageUrl: null},
      {order: 4, text: 'Proje durumunu listeden seçin.', imageUrl: null},
      {order: 5, text: 'İsterseniz proje kodu, tarihler, yönetici, müşteri ve bütçe bilgilerini girin.', imageUrl: null},
      {order: 6, text: '"Kaydet" butonuna tıklayın. Proje sisteme eklenir ve listede görünmeye başlar.', imageUrl: null},
    ],
    notes: [
      'Proje adı ve proje durumu zorunlu alanlardır.',
      'Proje oluşturulduktan sonra detay sayfasından görevler, belgeler ve maliyet kalemleri eklenebilir.',
    ],
  },
  {
    id: 'project-detail',
    category: 'Proje Yönetimi',
    title: 'Proje Detayını Görüntüleme ve Güncelleme',
    summary: 'Mevcut bir projenin tüm detaylarını görüntüleme, ilerleme durumunu takip etme ve bilgileri güncelleme adımları.',
    tags: ['proje', 'detay', 'güncelleme', 'durum', 'takip', 'ilerleme'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Projeler" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Listeden görüntülemek istediğiniz projeye tıklayın.', imageUrl: null},
      {order: 3, text: 'Proje detay sayfasında; genel bilgiler, görevler, belgeler ve mali özet gibi sekmeleri göreceksiniz.', imageUrl: null},
      {order: 4, text: 'Proje bilgilerini güncellemek için "Düzenle" veya "Güncelle" butonuna tıklayın.', imageUrl: null},
      {order: 5, text: 'Değiştirmek istediğiniz alanları düzenleyin (bitiş tarihi, bütçe, durum vb.).', imageUrl: null},
      {order: 6, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Proje tamamlandığında durumu "Tamamlandı" olarak güncelleyin. Bu sayede aktif proje listesi temiz kalır.',
      'Projeye bağlı görevler, giderler ve belgeler silinmeden projenin kendisi silinemez.',
    ],
  },
  {
    id: 'project-report',
    category: 'Proje Yönetimi',
    title: 'Proje Bazlı Rapor Alma',
    summary: 'Belirli bir projeye ait ilerleme, maliyet ve görev raporlarını görüntüleme ve dışa aktarma adımları.',
    tags: ['rapor', 'proje', 'maliyet', 'ilerleme', 'dışa aktarma', 'excel'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Projeler" modülüne gidin ve ilgili projeyi seçin.', imageUrl: null},
      {order: 2, text: 'Proje detay sayfasında "Raporlar" sekmesine tıklayın.', imageUrl: null},
      {order: 3, text: 'Görüntülemek istediğiniz rapor türünü seçin (ör. Maliyet Raporu, Görev Durumu, Faaliyet Özeti).', imageUrl: null},
      {order: 4, text: 'Tarih aralığı veya diğer filtre seçeneklerini belirleyin.', imageUrl: null},
      {order: 5, text: '"Raporu Oluştur" veya "Görüntüle" butonuna tıklayın.', imageUrl: null},
      {order: 6, text: 'Raporu dışa aktarmak için "Excel\'e Aktar" veya "PDF İndir" butonunu kullanın.', imageUrl: null},
    ],
    notes: [
      'Raporları düzenli aralıklarla alıp proje dosyanıza kaydetmek, ileriki denetimlerde ve müşteri toplantılarında kolaylık sağlar.',
    ],
  },

  // ─── Genel Kullanım ───────────────────────────────────────────────────────
  {
    id: 'general-filter-sort',
    category: 'Genel Kullanım',
    title: 'Listelerde Filtreleme ve Sıralama',
    summary: 'Sistemdeki herhangi bir listede veriyi filtreleme, arama ve sıralama ile aradığınızı hızlıca bulma adımları.',
    tags: ['filtre', 'sıralama', 'arama', 'liste', 'genel'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Filtrelemek istediğiniz modülün liste sayfasını açın (ör. Görevler, Projeler, Faturalar).', imageUrl: null},
      {order: 2, text: 'Listenin üst kısmındaki arama kutusuna aradığınız kelimeyi yazın; liste anında daraltılır.', imageUrl: null},
      {order: 3, text: '"Filtrele" butonuna veya filtre ikonuna tıklayarak gelişmiş filtre seçeneklerini açın.', imageUrl: null},
      {order: 4, text: 'Durum, tarih aralığı, kategori gibi kriterleri seçin ve "Uygula" butonuna tıklayın.', imageUrl: null},
      {order: 5, text: 'Sıralamak istediğiniz sütun başlığına tıklayın; veriler o sütuna göre artan sırayla dizilir. Tekrar tıkladığınızda azalan sıraya geçer.', imageUrl: null},
      {order: 6, text: 'Uyguladığınız filtreleri kaldırmak için "Filtreleri Temizle" veya "Sıfırla" butonunu kullanın.', imageUrl: null},
    ],
    notes: [
      'Sık kullandığınız filtre kombinasyonlarını not alın; her oturumda aynı filtreyi tekrar uygulamanız gerekebilir.',
    ],
  },
  {
    id: 'general-file-upload',
    category: 'Genel Kullanım',
    title: 'Belge ve Dosya Yükleme',
    summary: 'Masaüstü bilgisayardan sisteme belge, dosya veya görsel yükleme adımları.',
    tags: ['dosya', 'belge', 'yükleme', 'eklenti', 'masaüstü', 'pdf'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Dosya eklemek istediğiniz kayda gidin (proje, görev, fatura vb.).', imageUrl: null},
      {order: 2, text: '"Dosyalar", "Ekler" veya "Belgeler" sekmesine tıklayın.', imageUrl: null},
      {order: 3, text: '"Dosya Yükle" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 4, text: 'Açılan pencereden bilgisayarınızdaki dosyayı seçin ve "Aç" butonuna tıklayın.', imageUrl: null},
      {order: 5, text: 'Gerekiyorsa dosyaya açıklama veya etiket ekleyin.', imageUrl: null},
      {order: 6, text: '"Yükle" veya "Kaydet" butonuna tıklayın. Yükleme tamamlandığında dosya listede görünür.', imageUrl: null},
    ],
    notes: [
      'Sisteme yüklenebilecek dosya boyutu en fazla 400 MB\'tır.',
      'PDF, Word, Excel, görsel (JPG, PNG) ve video (MP4) formatları desteklenmektedir.',
    ],
  },
  {
    id: 'general-notifications',
    category: 'Genel Kullanım',
    title: 'Bildirimleri Yönetme',
    summary: 'Sistemden gelen bildirimleri görüntüleme, okundu olarak işaretleme ve bildirim ayarlarını yönetme adımları.',
    tags: ['bildirim', 'uyarı', 'onay', 'görev', 'takip'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Ekranın sağ üst köşesindeki zil ikonuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Açılan panelde size iletilen bildirimler listelenir: görev atamaları, onay talepleri, yaklaşan tarihler vb.', imageUrl: null},
      {order: 3, text: 'Bir bildirime tıkladığınızda ilgili kayda (görev, talep, proje) doğrudan yönlendirilirsiniz.', imageUrl: null},
      {order: 4, text: 'Tüm bildirimleri okundu olarak işaretlemek için paneldeki "Tümünü Okundu İşaretle" bağlantısına tıklayın.', imageUrl: null},
      {order: 5, text: 'Tüm bildirimlerin geçmişini görmek için "Tüm Bildirimler" bağlantısına tıklayın.', imageUrl: null},
    ],
    notes: [
      'Zil ikonu üzerindeki kırmızı rozet okunmamış bildirim sayısını gösterir.',
      'Önemli onay ve görev atamalarını kaçırmamak için sistemi düzenli olarak kontrol edin.',
    ],
  },

  // ─── Kullanıcı Görevleri ──────────────────────────────────────────────────
  {
    id: 'user-task-create',
    category: 'Kullanıcı Görevleri',
    title: 'Kullanıcı Görevi Oluşturma',
    summary: 'Kendinize veya başkalarına görev oluşturma ve görevin kime görüneceğini belirleme adımları.',
    tags: ['görev', 'kullanıcı', 'atama', 'proje ekibi', 'kendim', 'öncelik'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Görevlerim" veya "Kullanıcı Görevleri" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Görev" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Görev adını girin.', imageUrl: null},
      {order: 4, text: '"Kime atanacak?" alanından seçim yapın: Atanmış Kullanıcılar, Proje Ekibi, Tüm Kullanıcılar veya Sadece Kendim.', imageUrl: null},
      {order: 5, text: 'Görev tarihini seçin.', imageUrl: null},
      {order: 6, text: 'Öncelik seviyesini seçin (Acil, Yüksek, Orta, Düşük, Bilgi).', imageUrl: null},
      {order: 7, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Tek kişiye → Atanmış Kullanıcılar, bir projenin ekibine → Proje Ekibi, kendinize not almak için → Sadece Kendim seçeneğini tercih edin.',
      'Yetkilendirme türü değiştirildikten sonra daha önce seçilen kullanıcı veya proje bilgisi sıfırlanır.',
    ],
  },

  // ─── Sözleşmeler ──────────────────────────────────────────────────────────
  {
    id: 'contract-create',
    category: 'Sözleşmeler',
    title: 'Sözleşme Oluşturma',
    summary: 'Projeye bağlı yeni bir sözleşme kaydı açma, bilgileri girme ve önemli maddeleri sisteme kaydetme adımları.',
    tags: ['sözleşme', 'oluşturma', 'proje', 'şirket', 'imza', 'bitiş tarihi'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Sözleşmeler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Sözleşme" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 4, text: 'Sözleşme adını girin.', imageUrl: null},
      {order: 5, text: 'Sözleşme türünü seçin.', imageUrl: null},
      {order: 6, text: 'Sözleşme durumunu seçin.', imageUrl: null},
      {order: 7, text: 'Şirketi listeden seçin.', imageUrl: null},
      {order: 8, text: 'İsterseniz sözleşme numarası, imza tarihi, başlangıç tarihi, bitiş tarihi, süre ve toplam fiyat bilgilerini girin.', imageUrl: null},
      {order: 9, text: 'Sözleşmedeki kritik hükümleri "Önemli Maddeler" alanına girin.', imageUrl: null},
      {order: 10, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Proje, sözleşme adı, sözleşme türü, sözleşme durumu ve şirket alanları zorunludur.',
      'Bitiş tarihini girdikten sonra sistem kalan günü otomatik hesaplar ve liste ekranında renk koduyla gösterir.',
    ],
  },
  {
    id: 'contract-addendum',
    category: 'Sözleşmeler',
    title: 'Sözleşme Eki Ekleme',
    summary: 'Mevcut bir sözleşmeye ek hüküm veya süre uzatması ekleme adımları.',
    tags: ['sözleşme', 'ek', 'uzatma', 'hüküm', 'addendum', 'güncelleme'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Sözleşmeler" modülüne gidin ve ek eklemek istediğiniz sözleşmeye tıklayın.', imageUrl: null},
      {order: 2, text: 'Sözleşme detay sayfasında "Ekler" sekmesine tıklayın.', imageUrl: null},
      {order: 3, text: '"Ek Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 4, text: 'Açılan formda; Ek Tarihi, Ek Açıklaması, Uzatma Tarihi veya Uzatma Açıklaması alanlarından en az birini doldurun.', imageUrl: null},
      {order: 5, text: '"Kaydet" butonuna tıklayın. Ek, sözleşmeye bağlı olarak kaydedilir ve Ekler listesinde görünür.', imageUrl: null},
    ],
    notes: [
      'Dört alandan en az biri doldurulmalıdır; tümü boş bırakıldığında kayıt yapılamaz.',
      'Sözleşme süresi uzatıldığında uzatma tarihini girmeyi unutmayın. Yeni bitiş tarihi kalan gün hesabını günceller.',
    ],
  },
  {
    id: 'contract-list',
    category: 'Sözleşmeler',
    title: 'Sözleşme Listesinde Takip',
    summary: 'Sözleşme listesinde filtreleme yapma, bitiş tarihi yaklaşan sözleşmeleri takip etme ve Excel\'e aktarma adımları.',
    tags: ['sözleşme', 'liste', 'filtre', 'bitiş', 'takip', 'kalan gün', 'excel'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Sözleşmeler" modülüne gidin. Tüm sözleşmeler liste hâlinde görünür.', imageUrl: null},
      {order: 2, text: 'Kalan Gün sütunundaki renk kodlarına dikkat edin: kırmızı süresi geçmiş, sarı 30 gün içinde bitiyor, yeşil normal.', imageUrl: null},
      {order: 3, text: 'Belirli bir sözleşmeyi bulmak için proje, şirket, sözleşme türü veya durum filtrelerini kullanın.', imageUrl: null},
      {order: 4, text: 'Bitiş tarihi yaklaşan sözleşmeleri görmek için "Süresi Yakında Biten" alanına gün sayısı girin (ör. 30 gün içinde bitecekler).', imageUrl: null},
      {order: 5, text: 'Tarih aralığına göre filtrelemek için başlangıç / bitiş tarihi alanlarını kullanın.', imageUrl: null},
      {order: 6, text: 'Tüm listeyi Excel\'e aktarmak için "Excel\'e Aktar" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Sözleşme yönetiminde en kritik alan bitiş tarihidir. Sarı ve kırmızı renkteki sözleşmelere öncelik verin.',
      'Sözleşme uzatma yapıldıktan sonra "Mevcut Bitiş Tarihi" sütunu güncellenir. Kalan gün hesabı her zaman mevcut bitiş tarihini esas alır.',
    ],
  },

  // ─── Kasa ve Çekler ───────────────────────────────────────────────────────
  {
    id: 'bank-account-create',
    category: 'Kasa ve Çekler',
    title: 'Banka / Nakit Hesabı Oluşturma',
    summary: 'Sisteme yeni bir banka veya nakit hesabı ekleme ve temel bilgileri girme adımları.',
    tags: ['banka', 'hesap', 'nakit', 'kasa', 'iban', 'para birimi'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Kasa" veya "Banka / Hesaplar" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Hesap" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Hesap türünü seçin (Banka, Nakit veya Kredili Hesap).', imageUrl: null},
      {order: 4, text: 'Hesap adını girin.', imageUrl: null},
      {order: 5, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 6, text: 'Para birimini seçin (TRY, USD vb.).', imageUrl: null},
      {order: 7, text: 'Hesap türü Banka ise ek olarak banka adı, şube, hesap numarası ve IBAN bilgilerini girin.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Hesap türü, hesap adı, proje ve para birimi zorunlu alanlardır.',
      'Para birimini dikkatli seçin; sonradan değiştirilemez.',
    ],
  },
  {
    id: 'check-list',
    category: 'Kasa ve Çekler',
    title: 'Çek Listesinde Takip',
    summary: 'Alınan ve verilen çekleri listeleme, vade tarihi ve durum takibi yapma adımları.',
    tags: ['çek', 'liste', 'vade', 'durum', 'tahsil', 'alınan', 'verilen', 'takip'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Çekler" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Liste; çek numarası, tür, şirket, düzenlenme tarihi, vade tarihi, tutar, kullanılan ve kalan miktar bilgilerini gösterir.', imageUrl: null},
      {order: 3, text: 'Çek türü filtresinden Alınan veya Verilen seçerek listeyi daraltın.', imageUrl: null},
      {order: 4, text: 'Çek durumu filtresinden belirli durumdaki çekleri görüntüleyin.', imageUrl: null},
      {order: 5, text: 'Vade tarihi aralığı filtresini kullanarak vadesi yaklaşan çekleri listeleyin.', imageUrl: null},
      {order: 6, text: 'Detay görmek için ilgili çeke tıklayın.', imageUrl: null},
    ],
    notes: [
      'Vadesi yaklaşan çekleri düzenli takip edin. Vade tarihi geçmiş ödenmemiş çekler hukuki ve finansal risk oluşturabilir.',
    ],
  },
  {
    id: 'check-collection',
    category: 'Kasa ve Çekler',
    title: 'Alınan Çeki Tahsil Etme',
    summary: 'Müşteriden alınan çekin bankaya yatırılarak tahsil işleminin tamamlanması adımları.',
    tags: ['çek', 'tahsil', 'alınan çek', 'banka', 'hesap', 'tahsilat'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Çekler" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Tahsil etmek istediğiniz alınan çeke tıklayın.', imageUrl: null},
      {order: 3, text: 'Çek detay sayfasında "Tahsil İşlemi" sekmesine tıklayın.', imageUrl: null},
      {order: 4, text: 'Çekin yatırılacağı hesabı listeden seçin.', imageUrl: null},
      {order: 5, text: 'Tahsil tarihini girin.', imageUrl: null},
      {order: 6, text: 'İsterseniz açıklama girin.', imageUrl: null},
      {order: 7, text: '"Tahsil Et" veya "Kaydet" butonuna tıklayın.', imageUrl: null},
      {order: 8, text: 'İşlem tamamlandığında çekin durumu otomatik olarak "Tahsil Edildi" olarak güncellenir.', imageUrl: null},
    ],
    notes: [
      'Hesap ve tahsil tarihi zorunlu alanlardır.',
      'Tahsil işleminden önce çekin vadesi geldiğinden emin olun. Vadesi gelmemiş çekin bankaya yatırılması karşılıksız çek riskine yol açabilir.',
    ],
  },
  {
    id: 'check-payment',
    category: 'Kasa ve Çekler',
    title: 'Verilen Çeki Ödeme',
    summary: 'Tedarikçiye verilen çekin vade geldiğinde ödeme işleminin tamamlanması adımları.',
    tags: ['çek', 'ödeme', 'verilen çek', 'hesap', 'vade', 'tedarikçi'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Çekler" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Ödeme yapmak istediğiniz verilen çeke tıklayın.', imageUrl: null},
      {order: 3, text: 'Çek detay sayfasında "Ödeme İşlemi" sekmesine tıklayın.', imageUrl: null},
      {order: 4, text: 'Ödemenin yapılacağı hesabı listeden seçin.', imageUrl: null},
      {order: 5, text: 'Ödeme tarihini girin.', imageUrl: null},
      {order: 6, text: 'İsterseniz açıklama girin.', imageUrl: null},
      {order: 7, text: '"Öde" veya "Kaydet" butonuna tıklayın.', imageUrl: null},
      {order: 8, text: 'İşlem tamamlandığında çekin durumu otomatik olarak "Ödendi" olarak güncellenir.', imageUrl: null},
    ],
    notes: [
      'Hesap ve ödeme tarihi zorunlu alanlardır. Seçilen hesapta yeterli bakiye olduğundan emin olun.',
      'Vadesi yaklaşan verilen çekleri önceden takip etmek için Çek Listesinde vade tarihi filtresini kullanın.',
    ],
  },

  // ─── Başlangıç (ek) ───────────────────────────────────────────────────────
  {
    id: 'dashboard-overview',
    category: 'Başlangıç',
    title: 'Dashboard Kullanımı',
    summary: 'Sisteme giriş yaptıktan sonra karşılaşılan ana ekranın bileşenlerini tanıma ve günlük işlemlere buradan hızlıca erişme adımları.',
    tags: ['dashboard', 'ana ekran', 'görev', 'hesap', 'ödeme planı', 'takvim', 'döviz'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sisteme giriş yapıldığında doğrudan Dashboard (Ana Ekran) açılır. Sol menüden de erişilebilir.', imageUrl: null},
      {order: 2, text: 'Sayfanın üst kısmında kullanıcı adıyla kişiselleştirilmiş karşılama mesajı görüntülenir.', imageUrl: null},
      {order: 3, text: 'Görev Sayacı widget\'ı size atanmış açık görevlerin sayısını gösterir. Üzerine tıklayarak Görevlerim sayfasına geçebilirsiniz.', imageUrl: null},
      {order: 4, text: 'Döviz Kurları widget\'ı güncel kur bilgilerini listeler.', imageUrl: null},
      {order: 5, text: 'Banka/Nakit Hesapları bölümünde (banka yetkisi olan kullanıcılarda görünür) tüm hesapların toplam bakiyesi varsayılan para birimi ve diğer dövizler olarak özetlenir.', imageUrl: null},
      {order: 6, text: 'Aylık Ödeme Planı Grafiği o aya ait gider planları, satış planları ve nakit akışını çubuk grafik olarak gösterir.', imageUrl: null},
      {order: 7, text: 'Gider Ödeme Planları ve Satış Ödeme Planları tabloları yaklaşan planları proje filtresiyle gösterir. Tablodaki herhangi bir satıra tıklayarak ilgili fatura veya kayda geçebilirsiniz.', imageUrl: null},
      {order: 8, text: 'Takvim Mini Görünümü genel takvimden (sözleşmeler, çekler, projeler) yaklaşan etkinlikleri listeler.', imageUrl: null},
      {order: 9, text: 'İş Takvimi Mini Görünümü (iş takibi yetkisi olan kullanıcılarda görünür) iş programı görevlerini listeler.', imageUrl: null},
    ],
    notes: [
      'Dashboard\'da görünen bileşenler kullanıcının sahip olduğu rol ve yetkilere göre değişir.',
      'Dashboard\'u her gün işe başladığınızda genel durumu hızlıca kavramak için kullanın: bekleyen görevleri kontrol edin, o gün vadesi gelen ödeme planlarına bakın ve takvimden günün etkinliklerini görüntüleyin.',
    ],
  },

  // ─── Finans (ek) ──────────────────────────────────────────────────────────
  {
    id: 'gib-invoices-view',
    category: 'Finans',
    title: 'GİB e-Fatura Görüntüleme',
    summary: 'GİB sistemi üzerinden gelen tedarikçi e-faturalarını listeleme ve gider faturasına dönüştürme adımları.',
    tags: ['e-fatura', 'GİB', 'tedarikçi', 'fatura', 'gider', 'KDV', 'stopaj'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Giderler" → "GİB Faturaları" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'GİB sisteminden çekilen faturalar listelenir: GİB fatura numarası, düzenleme tarihi, tedarikçi adı, ödenecek tutar.', imageUrl: null},
      {order: 3, text: 'Sisteme kaydetmek istediğiniz faturaya tıklayın.', imageUrl: null},
      {order: 4, text: 'Açılan formda fatura bilgileri ön doldurulmuş gelir: ad, proje, firma, fatura türü, tarihler.', imageUrl: null},
      {order: 5, text: 'Eksik alanları tamamlayın ve fatura kalemlerini kontrol edin: ürün, miktar, birim, birim fiyat, vergi. İsteğe bağlı: iskonto, stopaj.', imageUrl: null},
      {order: 6, text: '"Kaydet" butonuna tıklayın. Fatura Giderler modülüne kaydedilir.', imageUrl: null},
    ],
    notes: [
      'GİB faturalarının gider modülüne kaydedilmesi için önce tedarikçinin sistem üzerinde tanımlı olması gerekir. Tanımlı olmayan tedarikçiler için önce Tedarikçi kaydı oluşturun.',
    ],
  },
  {
    id: 'payment-request-waiting',
    category: 'Finans',
    title: 'Onay Bekleyen Ödeme Talepleri',
    summary: 'Onay akışındaki bekleyen ödeme taleplerini proje, firma ve onaylayan bazında görüntüleme adımları.',
    tags: ['ödeme talebi', 'onay', 'bekleme', 'proje', 'firma', 'akış'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Giderler" → "Onay Bekleyenler" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Onay akışında bekleyen talepler listelenir: proje adı, firma ünvanı, talep eden kişi, onaylayacak kişi, onay seviyesi.', imageUrl: null},
      {order: 3, text: 'Filtreler: proje, firma, onaylayan kullanıcı. Uygun filtreyi seçerek listeyi daraltın.', imageUrl: null},
      {order: 4, text: 'Bir talebe tıklayarak ödeme talebi detay sayfasına gidebilir ve onay/red işlemini oradan gerçekleştirebilirsiniz.', imageUrl: null},
    ],
    notes: [
      'Bu ekran yalnızca sizin onaylayacağınız talepleri değil, sistemdeki tüm bekleyen talepleri gösterir. Kendi onay sırası gelen talepler size ayrıca bildirim olarak iletilir.',
    ],
  },
  {
    id: 'cash-payment-plan',
    category: 'Finans',
    title: 'Plansız Ödeme Planı Oluşturma',
    summary: 'Herhangi bir faturaya bağlı olmayan gider veya tahsilat ödeme planı kaydı açma adımları.',
    tags: ['ödeme planı', 'plansız', 'gider', 'tahsilat', 'proje', 'vade', 'kategori'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Kasa" → "Plansız Giderler" veya "Plansız Tahsilatlar" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Kayıt" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Adı girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Toplam tutarı girin.', imageUrl: null},
      {order: 6, text: 'İsteğe bağlı: vade tarihi, firma, kategori, açıklama.', imageUrl: null},
      {order: 7, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Ad, proje ve toplam tutar zorunlu alanlardır.',
      'Plansız ödeme planları Nakit Akışı Raporu\'nda ödeme/tahsilat planları tablosunda görünür. Kira, abonelik, avans ödemesi gibi faturaya bağlı olmayan dönemsel gider veya tahsilatları bu şekilde kaydedin.',
    ],
  },
  {
    id: 'sales-proposal-create',
    category: 'Finans',
    title: 'Satış Teklifi Oluşturma',
    summary: 'Müşteriye sunulmak üzere satış teklifi hazırlama, kalem ekleme ve teklif durumunu takip etme adımları.',
    tags: ['satış teklifi', 'teklif', 'müşteri', 'ürün', 'fiyat', 'iskonto', 'durum'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Satışlar" → "Teklifler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Teklif" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Teklif adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'İsteğe bağlı: müşteri firma, sorumlu personel, ödeme/teslimat koşulları, düzenleme tarihi, geçerlilik tarihi.', imageUrl: null},
      {order: 6, text: '"+ Kalem Ekle" butonuyla teklif kalemi ekleyin: ürün (zorunlu), miktar (zorunlu), birim (zorunlu), birim fiyat (zorunlu), vergi (zorunlu). İsteğe bağlı: iskonto, açıklama, stopaj.', imageUrl: null},
      {order: 7, text: 'Sayfa alt kısmında ara toplam, iskonto, KDV ve genel toplam otomatik hesaplanır.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın. Teklif "Değerlendiriliyor" durumunda oluşturulur.', imageUrl: null},
      {order: 9, text: 'Müşterinin kararına göre detay sayfasındaki durum alanından "Onaylandı" veya "Reddedildi" olarak güncelleyin.', imageUrl: null},
    ],
    notes: [
      'Teklif adı ve proje zorunludur. Her kalemin ürün, miktar, birim, birim fiyat ve vergi alanları doldurulmalıdır.',
      'Onaylanan tekliflerden satış faturası oluşturmak için detay sayfasındaki "Faturaya Dönüştür" seçeneğini kullanın.',
    ],
  },

  // ─── Yönetim (ek) ─────────────────────────────────────────────────────────
  {
    id: 'company-create',
    category: 'Yönetim',
    title: 'Şirket / Cari Oluşturma ve Detay Sayfası',
    summary: 'Sisteme yeni müşteri veya tedarikçi kaydı açma ve şirket detay sayfasındaki tüm bileşenleri kullanma adımları.',
    tags: ['şirket', 'cari', 'müşteri', 'tedarikçi', 'ekleme', 'detay', 'ödeme', 'tahsilat'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Müşteri için Sol menü → "Satışlar" → "Müşteriler"; tedarikçi için Sol menü → "Giderler" → "Tedarikçiler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Şirket" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Şirket adını (kısa kullanım adı) girin.', imageUrl: null},
      {order: 4, text: 'Şirket ünvanını (resmi ticari ünvan) girin.', imageUrl: null},
      {order: 5, text: 'İlgili projeyi / projeleri listeden seçin. Şirket yalnızca seçili projelerde görünür.', imageUrl: null},
      {order: 6, text: 'İsteğe bağlı: e-posta, telefon, faks, adres, il, ilçe, posta kodu.', imageUrl: null},
      {order: 7, text: 'İsteğe bağlı: vergi dairesi, vergi numarası, ticaret sicil numarası.', imageUrl: null},
      {order: 8, text: 'Fatura gönderimi için e-fatura türünü ve fatura e-posta adresini girin.', imageUrl: null},
      {order: 9, text: '"Yetkililer" bölümünden şirket iletişim kişisi ekleyin: ad soyad, telefon, e-posta. Birden fazla yetkili eklenebilir.', imageUrl: null},
      {order: 10, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Şirket adı, şirket ünvanı ve en az bir proje seçimi zorunludur. Ünvan e-fatura süreçlerinde kullanıldığından resmi ticari ünvanla birebir girilmesi önemlidir.',
      'Şirket detay sayfasında İşlemler, Giderler, Satış Faturaları, Projeler, Yetkililer ve Çek Ödemeleri sekmeleri ile sağ kenarda doğrudan ödeme/tahsilat formu yer alır.',
    ],
  },
  {
    id: 'product-create',
    category: 'Yönetim',
    title: 'Ürün / Stok Kalemi Oluşturma',
    summary: 'Gider, fatura ve iş takibi formlarında kullanılmak üzere sisteme yeni ürün veya stok kalemi ekleme adımları.',
    tags: ['ürün', 'stok', 'kalem', 'malzeme', 'fiyat', 'vergi', 'birim', 'ekleme'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Stok" → "Ürünler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Ürün" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Ürün adını girin.', imageUrl: null},
      {order: 4, text: 'Ürün birimini listeden seçin (ör. Adet, Kg, m², m³).', imageUrl: null},
      {order: 5, text: 'Vergiyi listeden seçin (ör. %18, %8, %0).', imageUrl: null},
      {order: 6, text: '"Stok takibi yapılsın mı?" seçeneğini belirleyin. Evet seçilirse sisteme giren/çıkan miktarlar takip edilir.', imageUrl: null},
      {order: 7, text: 'İsteğe bağlı: ürün kodu, kategori, alış ve satış fiyatları.', imageUrl: null},
      {order: 8, text: 'Stok alarmı kullanmak istiyorsanız "Stok alarmı aktif" seçeneğini açın ve alarm eşiği miktarını girin.', imageUrl: null},
      {order: 9, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Ürün adı, ürün birimi ve vergi zorunlu alanlardır. "Stok takibi yapılsın mı?" alanı da mutlaka seçilmelidir.',
      'Gider faturası, satış faturası veya iş takibi malzeme formlarında ürün seçimi yapılabilmesi için ürünün önceden bu sayfada tanımlanmış olması gerekir.',
    ],
  },

  // ─── Proje Yönetimi (ek) ──────────────────────────────────────────────────
  {
    id: 'construction-site-create',
    category: 'Proje Yönetimi',
    title: 'İnşaat Alanı ve Blok Oluşturma',
    summary: 'Projeye bağlı inşaat alanı tanımlama ve alanın altına blok ekleme adımları. İş takibi görevlerinde zorunlu olan bu yapının kurulumu.',
    tags: ['inşaat alanı', 'blok', 'proje', 'santiye', 'alan', 'görev', 'iş takibi'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '— İnşaat Alanı Oluşturma — Sol menüden "Projeler" → "İnşaat Alanları" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni İnşaat Alanı" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'İnşaat alanı adını girin (en fazla 50 karakter).', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin. İnşaat alanı seçilen projeye bağlanır.', imageUrl: null},
      {order: 5, text: 'Toplam iş miktarını girin.', imageUrl: null},
      {order: 6, text: 'İsteğe bağlı: il, ilçe, açık adres, açıklama.', imageUrl: null},
      {order: 7, text: '"Kaydet" butonuna tıklayın. İnşaat alanı adı, proje ve toplam iş miktarı zorunludur.', imageUrl: null},
      {order: 8, text: '— Blok Oluşturma — Sol menüden "Projeler" → "Bloklar" modülüne gidin.', imageUrl: null},
      {order: 9, text: '"Yeni Blok" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 10, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 11, text: 'Proje seçilince "İnşaat Alanı" alanı aktif hale gelir; ilgili inşaat alanını seçin.', imageUrl: null},
      {order: 12, text: 'Blok adını girin (en fazla 50 karakter).', imageUrl: null},
      {order: 13, text: 'Açıklamayı girin.', imageUrl: null},
      {order: 14, text: '"Kaydet" butonuna tıklayın. Proje, inşaat alanı, blok adı ve açıklama zorunludur.', imageUrl: null},
    ],
    notes: [
      'İş takibi görevleri proje → inşaat alanı → blok hiyerarşisine bağlıdır. Görev girilmeden önce bu yapının tanımlanmış olması gerekir.',
      'Büyük projelerde her bina veya sektör için ayrı blok tanımlayın. Bu ayrım, iş takibi raporlarında alan ve yapı bazlı filtreleme yapmanızı sağlar.',
    ],
  },
  {
    id: 'estate-create',
    category: 'Proje Yönetimi',
    title: 'Gayrimenkul (Taşınmaz) Oluşturma',
    summary: 'Gayrimenkul projesinde konut veya ticari taşınmaz kaydı açma, fiyatlama ve durum takibi adımları.',
    tags: ['gayrimenkul', 'taşınmaz', 'konut', 'satış', 'fiyat', 'vergi', 'durum', 'alan'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Projeler" → "Gayrimenkuller" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Gayrimenkul" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Adı girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Gayrimenkul durumunu seçin (ör. Satışa Hazır, Satıldı, Rezerve).', imageUrl: null},
      {order: 6, text: 'Temel alış fiyatını ve temel satış fiyatını girin.', imageUrl: null},
      {order: 7, text: 'Vergiyi listeden seçin. KDV\'li alış ve satış fiyatları otomatik hesaplanır.', imageUrl: null},
      {order: 8, text: 'İsteğe bağlı: gayrimenkul türü, brüt alan (m²), net alan (m²), il, ilçe, adres, açıklama, kategori.', imageUrl: null},
      {order: 9, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Ad, proje, durum, temel alış fiyatı, temel satış fiyatı ve vergi zorunlu alanlardır.',
      'Satış gerçekleştiğinde durumu "Satıldı" olarak güncelleyin. Detay sayfasından bağlı satış faturasına ulaşabilirsiniz.',
    ],
  },
  {
    id: 'plot-create',
    category: 'Proje Yönetimi',
    title: 'Parsel Oluşturma',
    summary: 'Proje → İnşaat Alanı → Blok → Bina Blok Tipi hiyerarşisine bağlı parsel tanımlama adımları.',
    tags: ['parsel', 'blok', 'inşaat alanı', 'bina blok tipi', 'proje', 'bodrum', 'hiyerarşi'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Projeler" → "Parseller" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Parsel" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 4, text: 'Proje seçilince "İnşaat Alanı" alanı aktif olur; ilgili inşaat alanını seçin.', imageUrl: null},
      {order: 5, text: 'İnşaat alanı seçilince "Blok" alanı aktif olur; ilgili bloğu seçin.', imageUrl: null},
      {order: 6, text: 'Blok seçilince "Bina Blok Tipi" alanı aktif olur; ilgili tipi seçin.', imageUrl: null},
      {order: 7, text: 'Parsel adını girin.', imageUrl: null},
      {order: 8, text: 'Bodrum yüksekliğini girin.', imageUrl: null},
      {order: 9, text: 'İsteğe bağlı: açıklama.', imageUrl: null},
      {order: 10, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Proje, inşaat alanı, blok, bina blok tipi, ad ve bodrum yüksekliği zorunlu alanlardır. Her alan bir önceki seçime bağlı olarak sırayla aktif hale gelir.',
      'Parsel oluşturmadan önce bina blok tipi tanımlanmış olmalıdır. Bina Blok Tipi ve Puantaj Şablonu kılavuzuna bakın.',
    ],
  },
  {
    id: 'project-config',
    category: 'Proje Yönetimi',
    title: 'Bina Blok Tipi ve Puantaj Şablonu Tanımlama',
    summary: 'Parsel oluşturmak için gereken bina blok tipi ve personel çalışma takibi için puantaj şablonu tanımlama adımları.',
    tags: ['bina blok tipi', 'puantaj şablonu', 'proje', 'yapılandırma', 'blok', 'sınıflandırma'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '— Bina Blok Tipi Tanımlama — Sol menüden "Projeler" → "Bina Blok Tipleri" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 4, text: 'Tip adını girin (en fazla 50 karakter). İsteğe bağlı: açıklama.', imageUrl: null},
      {order: 5, text: '"Kaydet" butonuna tıklayın. Proje ve tip adı zorunludur.', imageUrl: null},
      {order: 6, text: '— Puantaj Şablonu Tanımlama — Sol menüden "Projeler" → "Puantaj Şablonları" modülüne gidin.', imageUrl: null},
      {order: 7, text: '"+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 8, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 9, text: 'Şablon adını girin.', imageUrl: null},
      {order: 10, text: 'Veri sırasını girin (görünüm sıralaması için).', imageUrl: null},
      {order: 11, text: 'Puantaj türünü seçin (ör. Günlük, Haftalık, Göreve Göre).', imageUrl: null},
      {order: 12, text: '"Kaydet" butonuna tıklayın. Proje, şablon adı, veri sırası ve puantaj türü zorunludur.', imageUrl: null},
    ],
    notes: [
      'Bina blok tipi parsel oluşturmak için zorunludur; bloğun yapısal sınıflandırmasını tanımlar (ör. A Blok, Konut, Ticari).',
      'Puantaj şablonu faaliyet raporları ve aylık puantaj verilerinin doğru hesaplanması için gereklidir.',
    ],
  },

  // ─── Kasa ve Çekler (ek) ──────────────────────────────────────────────────
  {
    id: 'guarantee-letter-create',
    category: 'Kasa ve Çekler',
    title: 'Teminat Mektubu Oluşturma',
    summary: 'İhale veya sözleşme sürecinde verilen banka teminat mektubunu sisteme kaydetme adımları.',
    tags: ['teminat mektubu', 'banka', 'ihale', 'proje', 'firma', 'no', 'şube'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Kasa" → "Teminat Mektupları" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Teminat Mektubu" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Teminat mektubu adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Firmayı (lehdar firmayı) listeden seçin.', imageUrl: null},
      {order: 6, text: 'Bankayı listeden seçin.', imageUrl: null},
      {order: 7, text: 'Şube adını girin.', imageUrl: null},
      {order: 8, text: 'Teminat türünü seçin (ör. Geçici, Kesin, Avans).', imageUrl: null},
      {order: 9, text: 'Teminat durumunu seçin (ör. Aktif, İade Edildi).', imageUrl: null},
      {order: 10, text: 'Teminat mektubu numarasını girin.', imageUrl: null},
      {order: 11, text: 'Varlık türünü seçin (ör. Orijinal, Suret).', imageUrl: null},
      {order: 12, text: 'İsteğe bağlı: düzenleme tarihi, vade tarihi, tutar, banka komisyonu, faiz oranı.', imageUrl: null},
      {order: 13, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Ad, proje, firma, banka, şube, teminat türü, durum, teminat numarası ve varlık türü zorunlu alanlardır.',
      'Vade tarihini mutlaka girin. Vadesi yaklaşan teminat mektuplarını takip etmek için listeyi vade tarihine göre sıralayabilirsiniz.',
    ],
  },
  {
    id: 'cash-transactions',
    category: 'Kasa ve Çekler',
    title: 'Kasa Hareketleri Görüntüleme',
    summary: 'Sistemdeki tüm kasa ve banka hesabı hareketlerini filtreleme, sıralama ve Excel\'e aktarma adımları.',
    tags: ['kasa', 'hareket', 'işlem', 'hesap', 'filtre', 'tarih', 'tutar'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Kasa" → "Hareketler" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Liste; ad, hedef hesap, kaynak hesap, ödeme tarihi, işlem türü, resmiyet ve tutar sütunlarıyla görüntülenir.', imageUrl: null},
      {order: 3, text: 'Filtrelemek için üst paneli kullanın: hedef hesap, kaynak hesap, işlem türü, minimum/maksimum tutar, tarih aralığı.', imageUrl: null},
      {order: 4, text: '"Filtrele" butonuna tıklayın; liste daraltılır.', imageUrl: null},
      {order: 5, text: 'Sütun başlıklarına tıklayarak sıralama yapabilirsiniz.', imageUrl: null},
      {order: 6, text: '"Excel\'e Aktar" butonu ile filtrelenmiş sonuçları dışa aktarın.', imageUrl: null},
    ],
    notes: [
      'Belirli bir hesabın tüm giriş/çıkışlarını görmek için hedef hesap veya kaynak hesap filtresini tek başına kullanın.',
    ],
  },
  {
    id: 'bank-payment-order-create',
    category: 'Kasa ve Çekler',
    title: 'Banka Ödeme Emri Oluşturma',
    summary: 'Onaylanmış ödeme taleplerini seçerek toplu banka ödeme emri oluşturma adımları.',
    tags: ['ödeme emri', 'banka', 'toplu ödeme', 'onay', 'talep', 'tarih'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Kasa" → "Banka Ödeme Emirleri" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Ödeme Emri" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Ödeme emri adını girin.', imageUrl: null},
      {order: 4, text: 'Ödeme tarihini girin.', imageUrl: null},
      {order: 5, text: 'Ekranda onaylanmış ödeme taleplerinin listesi görüntülenir: proje, firma, onaylı tutar, talep tarihi.', imageUrl: null},
      {order: 6, text: 'Ödeme emrine dahil etmek istediğiniz talepleri seçin (en az bir seçim zorunludur).', imageUrl: null},
      {order: 7, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Ödeme emri adı, ödeme tarihi ve en az bir onaylı ödeme talebi seçimi zorunludur.',
      'Ödeme emrinde yalnızca onay akışını tamamlamış talepler listelenir. Henüz onaylanmamış talepler bu ekranda görünmez.',
    ],
  },
  {
    id: 'checkout-approve',
    category: 'Kasa ve Çekler',
    title: 'İşlem Onayı',
    summary: 'Kasa onay akışına düşen işlemleri listeleme ve onaylama veya reddetme adımları.',
    tags: ['onay', 'kasa', 'işlem', 'red', 'onayla', 'akış'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Kasa" → "İşlem Onayları" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Onay bekleyen işlemlerin listesi görüntülenir: işlem adı, tutar, tarih, talep eden kullanıcı.', imageUrl: null},
      {order: 3, text: 'Onaylamak veya reddetmek istediğiniz işleme tıklayın.', imageUrl: null},
      {order: 4, text: 'Açılan modal formda onay durumunu seçin (Onayla / Reddet).', imageUrl: null},
      {order: 5, text: '"Kaydet" butonuna tıklayın. İşlem, seçilen duruma göre güncellenir.', imageUrl: null},
    ],
    notes: [
      'Onaylanan işlemler otomatik olarak ilgili hesap hareketine dönüşür. Reddedilen işlemler talep sahibine bildirim göndererek geri döner.',
    ],
  },

  // ─── Personel Yönetimi ────────────────────────────────────────────────────
  {
    id: 'staff-create',
    category: 'Personel Yönetimi',
    title: 'Personel Oluşturma ve Detay Sayfası',
    summary: 'Sisteme yeni personel kaydı ekleme ve personel detay sayfasındaki tüm bileşenleri kullanma adımları.',
    tags: ['personel', 'çalışan', 'ekleme', 'maaş', 'izin', 'mesai', 'proje', 'sertifika'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Personel" → "Personel Listesi" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Personel" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Ad Soyad alanını doldurun.', imageUrl: null},
      {order: 4, text: 'İlgili projeyi / projeleri listeden seçin (en az bir proje zorunludur).', imageUrl: null},
      {order: 5, text: 'İsteğe bağlı: unvan, kategori, TC kimlik numarası, sicil numarası, telefon, IBAN, e-posta, adres, kan grubu, acil iletişim kişisi bilgisi, işe başlama tarihi, ayrılma tarihi, aylık maaş.', imageUrl: null},
      {order: 6, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Ad Soyad ve en az bir proje seçimi zorunludur.',
      'Personel detay sayfasında Genel, İşlemler, Maaş, İzin, Fazla Mesai, Projeler, Dosyalar ve Sertifikalar sekmeleri; sağ kenarda ise avans/ödeme formu yer alır.',
    ],
  },
  {
    id: 'staff-leave-create',
    category: 'Personel Yönetimi',
    title: 'İzin Kaydı Oluşturma',
    summary: 'Personel için izin kaydı açma; izin türü, gün sayısı ve tarih bilgilerini girme adımları.',
    tags: ['izin', 'personel', 'gün sayısı', 'başlangıç', 'bitiş', 'tür'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Personel" → "İzinler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni İzin" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Personeli listeden seçin.', imageUrl: null},
      {order: 4, text: 'İzin türünü listeden seçin (ör. Yıllık İzin, Mazeret İzni, Ücretsiz İzin).', imageUrl: null},
      {order: 5, text: 'Gün sayısını girin (sıfırdan büyük olmalıdır).', imageUrl: null},
      {order: 6, text: 'İsteğe bağlı: başlangıç tarihi, bitiş tarihi, açıklama.', imageUrl: null},
      {order: 7, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Personel, izin türü ve gün sayısı zorunlu alanlardır.',
      'Personelin toplam kazanılmış izin bakiyesi, personel detay sayfasının Genel sekmesinde görüntülenebilir.',
    ],
  },
  {
    id: 'staff-overtime-create',
    category: 'Personel Yönetimi',
    title: 'Fazla Mesai Kaydı Oluşturma',
    summary: 'Personel için fazla mesai kaydı açma; mesai türü, tarih ve saat süresi bilgilerini girme adımları.',
    tags: ['fazla mesai', 'mesai', 'personel', 'saat', 'tür', 'tarih'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Personel" → "Fazla Mesailer" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Fazla Mesai" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Personeli listeden seçin.', imageUrl: null},
      {order: 4, text: 'Mesai türünü listeden seçin (ör. Normal Mesai, Bayram Mesaisi, Pazar Mesaisi).', imageUrl: null},
      {order: 5, text: 'Başlangıç tarihini seçin.', imageUrl: null},
      {order: 6, text: 'Saat süresini girin (sıfırdan büyük olmalıdır).', imageUrl: null},
      {order: 7, text: 'İsteğe bağlı: açıklama.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Personel, mesai türü, başlangıç tarihi ve saat süresi zorunlu alanlardır.',
    ],
  },
  {
    id: 'staff-salary-create',
    category: 'Personel Yönetimi',
    title: 'Maaş Ödemesi Oluşturma',
    summary: 'Personele proje bazında maaş ödemesi kaydı açma ve ödeme durumuna göre ilgili alanları doldurma adımları.',
    tags: ['maaş', 'ödeme', 'personel', 'proje', 'hakediş', 'hesap', 'vade'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Personel" → "Maaş Ödemeleri" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Maaş Ödemesi" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Personeli listeden seçin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Hakediş tarihini girin.', imageUrl: null},
      {order: 6, text: 'Ödeme tutarını girin (sıfırdan büyük olmalıdır).', imageUrl: null},
      {order: 7, text: 'Ödeme durumunu seçin: "Ödendi" seçilirse ödeme tarihi ve hesap zorunlu olur; "Ödenecek" seçilirse vade tarihi zorunlu olur.', imageUrl: null},
      {order: 8, text: 'İsteğe bağlı: açıklama.', imageUrl: null},
      {order: 9, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      '"Ödenecek" olarak kaydedilen maaş ödemeleri personel detay sayfasının Maaş sekmesinde bakiye olarak görünür. Ödeme yapıldığında detay sayfasındaki ödeme formu kullanılarak hesap hareketine dönüştürülür.',
    ],
  },
  {
    id: 'staff-monthly-salary',
    category: 'Personel Yönetimi',
    title: 'Aylık Toplu Maaş İşlemi',
    summary: 'Proje bazında tüm personelin aylık maaşlarını toplu olarak güncelleme ve ödeme işlemi başlatma adımları.',
    tags: ['aylık maaş', 'toplu', 'personel', 'proje', 'BES', 'hakediş', 'ödeme'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Personel" → "Aylık Maaş" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Aylık Maaş" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 4, text: 'Hakediş tarihini girin.', imageUrl: null},
      {order: 5, text: 'Vade tarihini girin.', imageUrl: null},
      {order: 6, text: 'Açıklamayı girin.', imageUrl: null},
      {order: 7, text: 'Açılan tabloda projeye bağlı tüm personel listelenir. Her satır için ödeme tutarını ve BES ödeme tutarını girin.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
      {order: 9, text: 'Kayıt oluşturulduktan sonra detay sayfasındaki ödeme formundan toplu ödeme yapılabilir: ödeme adı, hesap ve ödeme tarihi girilerek tüm personele ödeme gönderilir.', imageUrl: null},
    ],
    notes: [
      'Proje, hakediş tarihi, vade tarihi ve açıklama zorunludur. Her personel satırında ödeme ve BES tutarı sıfırdan büyük olmalıdır.',
      'Bu modül her ay tekrar edecek şekilde kullanılır. Önceki aya ait kaydı referans alarak personel listesi aynı kalır; yalnızca tutarları ve tarihleri güncelleyin.',
    ],
  },

  // ─── Satın Alma ───────────────────────────────────────────────────────────
  {
    id: 'purchase-request-create',
    category: 'Satın Alma',
    title: 'Satın Alma Talebi Oluşturma',
    summary: 'Malzeme veya hizmet alımı için satın alma talebi açma ve ürün listesi ekleme adımları. Satın alma akışının başlangıç adımı.',
    tags: ['satın alma', 'talep', 'ürün', 'miktar', 'proje', 'tedarik', 'durum'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Satın Alma" → "Talepler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Talep" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Talep adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Talep durumunu seçin (ör. Yeni, Yanıt Bekleniyor, Onay Bekleniyor).', imageUrl: null},
      {order: 6, text: 'İsteğe bağlı: tedarikçi firma, talep tarihi, ihtiyaç tarihi, sorumlu personel, not, dosya eki.', imageUrl: null},
      {order: 7, text: '"+ Kalem Ekle" butonuyla ürün satırı ekleyin: ürün (zorunlu), miktar (zorunlu), birim, açıklama. Birden fazla kalem için tekrarlayın.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Talep adı, proje, durum ve en az bir ürün kalemi zorunludur.',
      'Akış: Satın Alma Talebi → Teklif Alma → Satın Alma Siparişi.',
    ],
  },
  {
    id: 'purchase-proposal',
    category: 'Satın Alma',
    title: 'Teklif Firması Ekleme ve Teklif Alma',
    summary: 'Satın alma sürecinde teklif alınacak firmayı sisteme ekleme ve firmadan fiyat teklifi alma adımları.',
    tags: ['teklif', 'firma', 'satın alma', 'fiyat', 'belge', 'teslimat', 'KDV'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '— Teklif Firması Ekleme — Sol menüden "Satın Alma" → "Teklif Firmaları" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Firma" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Firmanın adını, e-posta adresini ve telefon numarasını girin.', imageUrl: null},
      {order: 4, text: '"Yetkililer" bölümünden iletişim kişisi ekleyin (ad soyad, telefon, e-posta). İsteğe bağlı: adres, not.', imageUrl: null},
      {order: 5, text: '"Kaydet" butonuna tıklayın. Firma adı, e-posta ve telefon zorunludur.', imageUrl: null},
      {order: 6, text: '— Teklif Alma — Satın alma talebi detay sayfasına gidin.', imageUrl: null},
      {order: 7, text: 'Teklif almak istediğiniz firmayı seçerek teklif daveti gönderin.', imageUrl: null},
      {order: 8, text: 'Firma teklif formunu doldurur: toplam tutar (zorunlu), KDV\'li toplam tutar (zorunlu), teklif belgesi (zorunlu). İsteğe bağlı: ödeme koşulları, teslimat süresi, nakliye bilgisi, marka.', imageUrl: null},
      {order: 9, text: 'Gelen teklifler talep detay sayfasında listelenir; firmalar arası karşılaştırma yapılabilir.', imageUrl: null},
    ],
    notes: [],
  },
  {
    id: 'purchase-order-create',
    category: 'Satın Alma',
    title: 'Satın Alma Siparişi Oluşturma',
    summary: 'Onaylanan teklif sonrasında tedarikçiye resmi satın alma siparişi oluşturma ve teslimat bilgilerini girme adımları.',
    tags: ['sipariş', 'satın alma', 'tedarikçi', 'teslimat', 'ürün', 'proje'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Satın Alma" → "Siparişler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Sipariş" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Sipariş adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Sipariş durumunu seçin (Beklemede, Teslim Edildi, İptal Edildi).', imageUrl: null},
      {order: 6, text: 'İsteğe bağlı: tedarikçi firma, kesim tarihi, sevkiyat tarihi, teslimat tarihi, teslimat adresi, sorumlu personel, not.', imageUrl: null},
      {order: 7, text: '"+ Kalem Ekle" butonuyla ürün satırı ekleyin: ürün (zorunlu), miktar (zorunlu), birim, açıklama.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Sipariş adı, proje, durum ve en az bir ürün kalemi zorunludur.',
      'Sipariş teslim alındığında durumu "Teslim Edildi" olarak güncelleyin.',
    ],
  },

  // ─── Stok ve Depo ─────────────────────────────────────────────────────────
  {
    id: 'warehouse-create',
    category: 'Stok ve Depo',
    title: 'Depo Oluşturma',
    summary: 'Stok hareketlerinde kullanılmak üzere sisteme yeni depo kaydı ekleme adımları.',
    tags: ['depo', 'stok', 'oluşturma', 'proje', 'konum', 'varsayılan'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Stok" → "Depolar" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Depo" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Depo adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'İsteğe bağlı: il, ilçe, adres.', imageUrl: null},
      {order: 6, text: '"Kaydet" butonuna tıklayın.', imageUrl: null},
    ],
    notes: [
      'Depo adı ve proje zorunlu alanlardır.',
      'Depo listesinde "Varsayılan Depo" rozeti olan depo, irsaliye ve transfer işlemlerinde otomatik olarak önerilir. Projeye birden fazla depo tanımlanabilir.',
    ],
  },
  {
    id: 'stock-inwaybill-create',
    category: 'Stok ve Depo',
    title: 'Giriş İrsaliyesi Oluşturma',
    summary: 'Tedarikçiden gelen malzemeyi depoya kaydetmek için giriş irsaliyesi oluşturma adımları.',
    tags: ['giriş irsaliyesi', 'stok', 'depo', 'malzeme', 'tedarikçi', 'miktar'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Stok" → "Giriş İrsaliyeleri" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni İrsaliye" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'İrsaliye adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'İsteğe bağlı: tedarikçi firma, sevkiyat adresi, çıkış adresi, sevkiyat türü, düzenleme tarihi, sevkiyat tarihi, irsaliye numarası.', imageUrl: null},
      {order: 6, text: '"+ Kalem Ekle" butonuyla ürün satırı ekleyin: ürün (zorunlu), depo (zorunlu), miktar (zorunlu).', imageUrl: null},
      {order: 7, text: 'Birden fazla ürün için 6. adımı tekrarlayın.', imageUrl: null},
      {order: 8, text: '"Kaydet" butonuna tıklayın. Her kalem kaydedilen depodaki stok miktarına eklenir.', imageUrl: null},
    ],
    notes: [
      'İrsaliye adı, proje ve her kalemin ürün, depo ve miktar alanları zorunludur.',
    ],
  },
  {
    id: 'stock-outwaybill-create',
    category: 'Stok ve Depo',
    title: 'Çıkış İrsaliyesi Oluşturma',
    summary: 'Depodan çıkan malzemeyi kaydetmek için çıkış irsaliyesi oluşturma adımları.',
    tags: ['çıkış irsaliyesi', 'stok', 'depo', 'malzeme', 'sevkiyat', 'firma'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Stok" → "Çıkış İrsaliyeleri" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni İrsaliye" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'İrsaliye adını girin.', imageUrl: null},
      {order: 4, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 5, text: 'Alıcı firmayı listeden seçin.', imageUrl: null},
      {order: 6, text: 'Sevkiyat ilçesini seçin.', imageUrl: null},
      {order: 7, text: 'İsteğe bağlı: sevkiyat/çıkış adresleri, sevkiyat türü, tarihler, irsaliye numarası.', imageUrl: null},
      {order: 8, text: '"+ Kalem Ekle" butonuyla ürün satırı ekleyin: ürün (zorunlu), depo (zorunlu), miktar (zorunlu).', imageUrl: null},
      {order: 9, text: '"Kaydet" butonuna tıklayın. Her kalem kaydedilen depodaki stok miktarından düşülür.', imageUrl: null},
    ],
    notes: [
      'İrsaliye adı, proje, alıcı firma, sevkiyat ilçesi ve her kalemin ürün, depo ve miktarı zorunludur.',
      'Çıkış miktarı depodaki mevcut stok miktarını aşamaz; yetersiz stok varsa kayıt yapılamaz.',
    ],
  },
  {
    id: 'stock-transfer-create',
    category: 'Stok ve Depo',
    title: 'Depolar Arası Transfer',
    summary: 'Bir depodaki malzemeyi başka bir depoya transfer etmek için transfer kaydı oluşturma adımları.',
    tags: ['transfer', 'depo', 'stok', 'çıkış', 'varış', 'malzeme', 'miktar'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Stok" → "Transferler" modülüne gidin.', imageUrl: null},
      {order: 2, text: '"Yeni Transfer" veya "+ Ekle" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Projeyi listeden seçin.', imageUrl: null},
      {order: 4, text: 'Çıkış deposunu listeden seçin.', imageUrl: null},
      {order: 5, text: 'Varış deposunu listeden seçin.', imageUrl: null},
      {order: 6, text: 'Çıkış tarihini girin.', imageUrl: null},
      {order: 7, text: 'Sevkiyat tarihini girin.', imageUrl: null},
      {order: 8, text: 'İsteğe bağlı: transfer adı, teslim eden kişi, teslim alan kişi.', imageUrl: null},
      {order: 9, text: '"+ Kalem Ekle" butonuyla ürün satırı ekleyin: ürün (zorunlu), miktar (zorunlu, sıfırdan büyük).', imageUrl: null},
      {order: 10, text: '"Kaydet" butonuna tıklayın. Çıkış deposundan düşülen miktar varış deposuna eklenir.', imageUrl: null},
    ],
    notes: [
      'Proje, çıkış deposu, varış deposu, çıkış tarihi, sevkiyat tarihi ve en az bir kalemin ürün ve miktarı zorunludur.',
    ],
  },

  // ─── Raporlar ─────────────────────────────────────────────────────────────
  {
    id: 'report-cash-flow',
    category: 'Raporlar',
    title: 'Nakit Akışı Raporu',
    summary: 'Tüm banka ve nakit hesaplarının güncel bakiyelerini, gelecek tahsilat ve ödeme planlarını tek ekranda görüntüleme.',
    tags: ['nakit akışı', 'banka', 'hesap', 'tahsilat', 'ödeme planı', 'rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Raporlar" → "Nakit Akışı" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Sayfa açılınca veriler otomatik yüklenir; ek filtre gerekmez.', imageUrl: null},
      {order: 3, text: 'Üst panelde banka ve nakit hesaplarının güncel bakiyeleri varsayılan para birimi ve diğer dövizler ayrımıyla gösterilir.', imageUrl: null},
      {order: 4, text: 'Yıllık grafik; Gider Ödeme Planları, Satış Planları ve Nakit Akışı serilerini karşılaştırır.', imageUrl: null},
      {order: 5, text: 'Aylık grafik aynı serilerle o ayki detayı gösterir.', imageUrl: null},
      {order: 6, text: 'Gider Ödeme Planları tablosunda yaklaşan ödemeler; plan adı, tedarikçi, vade tarihi ve tutar sütunlarıyla listelenir.', imageUrl: null},
      {order: 7, text: 'Satış Ödeme Planları tablosunda aynı yapıyla tahsilat planları yer alır.', imageUrl: null},
      {order: 8, text: 'Yıllık Özet ve Aylık Özet tablolarında nakit akışı, gider ve satış toplamları görüntülenebilir.', imageUrl: null},
    ],
    notes: [
      'Bu rapor proje veya tarih filtresi içermez; kiracıya ait tüm verileri gösterir. Belirli bir döneme odaklanmak için Gider Faturası veya Satış Faturası raporlarını kullanın.',
    ],
  },
  {
    id: 'report-expense-invoice',
    category: 'Raporlar',
    title: 'Gider Faturası Raporu',
    summary: 'Gider faturalarını durum, kategori, proje ve tarihe göre grafik olarak analiz etme adımları.',
    tags: ['gider', 'fatura', 'rapor', 'grafik', 'kategori', 'proje', 'durum'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Raporlar" → "Gider Faturası Raporu" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Başlangıç tarihi ve bitiş tarihini seçin (varsayılan: o ayın 1\'i – bugün).', imageUrl: null},
      {order: 3, text: 'İsteğe bağlı filtreler: gider kategorisi, ödeme durumu, personel, proje.', imageUrl: null},
      {order: 4, text: '"Filtrele" butonuna tıklayın; grafikler seçilen kriterlere göre güncellenir.', imageUrl: null},
      {order: 5, text: 'Durum pasta grafiği — hangi ödeme durumundaki faturaların toplam tutarda ne kadar pay tuttuğunu gösterir.', imageUrl: null},
      {order: 6, text: 'Aylık sütun grafiği — seçili dönemde aylara göre gider dağılımını gösterir.', imageUrl: null},
      {order: 7, text: 'Kategori sütun grafiği — hangi gider kategorisinin toplam tutarın ne kadarını oluşturduğunu gösterir.', imageUrl: null},
      {order: 8, text: 'Proje sütun grafiği — gider toplamlarını proje bazında karşılaştırır.', imageUrl: null},
      {order: 9, text: 'Tarihe göre grafik — bireysel fatura tutarlarını zaman çizelgesinde gösterir.', imageUrl: null},
    ],
    notes: [
      'Filtreleri temizleyip tüm dönem verisini yükleyerek hangi kategorinin yıllık bazda en fazla gideri oluşturduğunu görebilirsiniz.',
    ],
  },
  {
    id: 'report-sale-invoice',
    category: 'Raporlar',
    title: 'Satış Faturası Raporu',
    summary: 'Satış faturalarını durum, kategori ve projeye göre grafik olarak analiz etme; gayrimenkul projelerinde daire satış takibi.',
    tags: ['satış', 'fatura', 'rapor', 'grafik', 'proje', 'tahsilat', 'gayrimenkul'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Raporlar" → "Satış Faturası Raporu" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Başlangıç ve bitiş tarihini seçin.', imageUrl: null},
      {order: 3, text: 'İsteğe bağlı filtreler: satış kategorisi, ödeme durumu, proje.', imageUrl: null},
      {order: 4, text: '"Filtrele" butonuna tıklayın.', imageUrl: null},
      {order: 5, text: 'Durum pasta grafiği — tahsil edilen ve tahsil edilecek fatura oranlarını gösterir.', imageUrl: null},
      {order: 6, text: 'Aylık sütun grafiği — aylara göre satış geliri dağılımını gösterir.', imageUrl: null},
      {order: 7, text: 'Kategori sütun grafiği — satış türlerine (konut, ticari vb.) göre gelir dağılımını gösterir.', imageUrl: null},
      {order: 8, text: 'Proje sütun grafiği — proje bazında toplam satış gelirlerini karşılaştırır.', imageUrl: null},
      {order: 9, text: 'Gayrimenkul aylık grafiği — yalnızca gayrimenkul projelerinde görünür; daire satışlarını ay bazında takip eder.', imageUrl: null},
      {order: 10, text: 'Tarihe göre grafik — bireysel fatura tutarlarını zaman çizelgesinde listeler.', imageUrl: null},
    ],
    notes: [
      'Tahsilat gecikmelerini takip etmek için ödeme durumu filtresini "Tahsil Edilecek" olarak ayarlayın.',
    ],
  },
  {
    id: 'report-work-program',
    category: 'Raporlar',
    title: 'İş Programı Raporu',
    summary: 'Seçilen projenin iş programı ilerlemesini; proje, inşaat alanı, kök görev ve blok bazında grafik olarak takip etme adımları.',
    tags: ['iş programı', 'tamamlanma', 'görev', 'inşaat alanı', 'blok', 'personel', 'rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Raporlar" → "İş Programı Raporu" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'Projeyi listeden seçin (zorunlu). Seçim yapılmadan grafikler yüklenmez.', imageUrl: null},
      {order: 3, text: 'Proje tamamlanma oranı halka grafiği — projenin genel yüzdesini Kalan İş / Tamamlanan İş ayrımıyla gösterir.', imageUrl: null},
      {order: 4, text: 'İnşaat alanı bazlı sütun grafiği — her inşaat alanının tamamlanma oranını karşılaştırmalı gösterir.', imageUrl: null},
      {order: 5, text: 'Kök görev bazlı yatay çubuk grafik — ana görevlerin tamamlanma oranlarını sıralar.', imageUrl: null},
      {order: 6, text: 'Günlük personel sayısı çizgi grafiği — sahada günlük çalışan kişi sayısını zaman serisi olarak gösterir.', imageUrl: null},
      {order: 7, text: 'Faaliyet raporu iş ilerlemesi çizgi grafiği — tamamlanan, kalan ve günlük iş miktarlarını gösterir.', imageUrl: null},
      {order: 8, text: 'Blok bazlı sütun grafikler — her inşaat alanı için ayrı grafik oluşturulur; blok blok tamamlanma oranları gösterilir.', imageUrl: null},
    ],
    notes: [
      'Bu rapor yalnızca iş takibi (workplan) modülüne veri girilmiş projeler için anlamlı sonuç verir. Faaliyet raporu ve görev güncellemeleri düzenli girilmezse grafikler eksik görünür.',
    ],
  },
  {
    id: 'report-audit',
    category: 'Raporlar',
    title: 'Denetim Raporu',
    summary: 'Sistemde kimin ne zaman hangi işlemi yaptığını görüntüleme; kullanıcı ve tarih bazında işlem geçmişini sorgulama adımları.',
    tags: ['denetim', 'audit', 'log', 'işlem geçmişi', 'kullanıcı', 'tarih', 'yönetim'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Raporlar" → "Denetim Raporu" modülüne gidin.', imageUrl: null},
      {order: 2, text: 'İsteğe bağlı filtreler: kullanıcı, işlem türü, başlangıç tarihi, bitiş tarihi.', imageUrl: null},
      {order: 3, text: '"Filtrele" butonuna tıklayın.', imageUrl: null},
      {order: 4, text: 'Listede her satır bir işlem kaydını gösterir: işlemi yapan kullanıcı, işlem türü ve tarih/saat.', imageUrl: null},
      {order: 5, text: 'Sütun başlıklarına tıklayarak kullanıcı adı veya tarihe göre sıralama yapabilirsiniz.', imageUrl: null},
    ],
    notes: [
      'Bu rapor yalnızca denetim yetkisine sahip kullanıcılar tarafından görüntülenebilir.',
      'Belirli bir işlemin kimin tarafından yapıldığını araştırmak için tarih aralığını daraltın ve kullanıcı filtresini birlikte kullanın.',
    ],
  },
  {
    id: 'report-dynamic-pivot',
    category: 'Raporlar',
    title: 'Dinamik Raporlarda Pivot Tablo Kullanımı',
    summary: 'Dinamik raporlardaki pivot tablo aracını kullanarak verileri gruplama, sıralama, filtreleme ve dışa aktarma adımları.',
    tags: ['dinamik rapor', 'pivot', 'tablo', 'gruplama', 'excel', 'dışa aktarma'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: 'Sol menüden "Raporlar" → "Dinamik Raporlar" bölümüne gidin; izninizin olduğu raporlar listelenir.', imageUrl: null},
      {order: 2, text: 'Görüntülemek istediğiniz rapora tıklayın.', imageUrl: null},
      {order: 3, text: 'Proje veya inşaat alanı filtresi gerektiren raporlarda önce ilgili seçimi yapın ve "Getir" butonuna tıklayın.', imageUrl: null},
      {order: 4, text: 'Pivot tablo yüklendikten sonra sütun başlıklarını "Satırlar" veya "Sütunlar" alanına sürükleyerek verileri farklı boyutlarda gruplayabilirsiniz.', imageUrl: null},
      {order: 5, text: 'Belirli değerlere odaklanmak için sütun başlığındaki filtre ikonuna tıklayarak satır bazlı filtre uygulayabilirsiniz.', imageUrl: null},
      {order: 6, text: 'Herhangi bir hücreye tıklandığında o değere ait detay satırlar açılır (drill-down).', imageUrl: null},
      {order: 7, text: 'Veriyi dışa aktarmak için araç çubuğundaki "Excel\'e Aktar" veya "PDF" butonunu kullanın.', imageUrl: null},
    ],
    notes: [
      'Pivot tablonun sütun düzenini değiştirdiğinizde sayfa yenilenene kadar bu düzen korunur. Başlangıç düzenine dönmek için sayfayı yenileyin.',
    ],
  },
  {
    id: 'report-sale-payment-plan',
    category: 'Raporlar',
    title: 'Satış Faturası Ödeme Planı Raporu',
    summary: 'Satış faturalarına bağlı tahsilat planlarını müşteri, proje ve vade tarihi bazında pivot tabloda görüntüleme.',
    tags: ['satış', 'ödeme planı', 'tahsilat', 'vade', 'dinamik rapor', 'pivot'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Satış Faturası Ödeme Planı" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Filtre gerekmez; tüm ödeme planları otomatik yüklenir.', imageUrl: null},
      {order: 3, text: 'Müşteri, proje veya vade tarihine göre gruplamak için ilgili sütunu pivot tablo satır alanına sürükleyin.', imageUrl: null},
      {order: 4, text: 'Belirli bir dönemi görmek için vade tarihi sütununa filtre uygulayın.', imageUrl: null},
      {order: 5, text: '"Excel\'e Aktar" butonu ile veriyi dışa aktarın.', imageUrl: null},
    ],
    notes: [
      'Vadesi geciken tahsilatları bulmak için vade tarihi sütununa bugünden önceki tarihleri filtreleyin.',
    ],
  },
  {
    id: 'report-expense-payment-plan',
    category: 'Raporlar',
    title: 'Gider Faturası Ödeme Planı Raporu',
    summary: 'Gider faturalarına bağlı ödeme planlarını tedarikçi, proje ve vade tarihi bazında pivot tabloda görüntüleme.',
    tags: ['gider', 'ödeme planı', 'tedarikçi', 'vade', 'dinamik rapor', 'pivot'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Gider Faturası Ödeme Planı" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Tüm gider ödeme planları filtre olmadan otomatik yüklenir.', imageUrl: null},
      {order: 3, text: 'Tedarikçi, proje veya vade tarihine göre gruplamak için ilgili sütunu satır alanına sürükleyin.', imageUrl: null},
      {order: 4, text: '"Excel\'e Aktar" ile veriyi dışa aktarın.', imageUrl: null},
    ],
    notes: [
      'Haftalık ödeme planlaması yaparken bu raporu proje + vade tarihi bazında gruplayarak o haftaki yükümlülüklerinizi toplu görün.',
    ],
  },
  {
    id: 'report-sale-with-balance',
    category: 'Raporlar',
    title: 'Bakiyeli Satış Faturaları Raporu',
    summary: 'Henüz tahsil edilmemiş bakiyesi olan satış faturalarını müşteri, tutar ve vade bazında pivot tabloda görüntüleme.',
    tags: ['satış', 'bakiye', 'tahsilat', 'alacak', 'fatura', 'dinamik rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Bakiyeli Satış Faturaları" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Bakiyesi olan tüm faturalar otomatik yüklenir; filtre gerekmez.', imageUrl: null},
      {order: 3, text: 'Müşteri bazında gruplamak için müşteri sütununu pivot tablo satır alanına sürükleyin.', imageUrl: null},
      {order: 4, text: 'Vade tarihine göre sıralayarak en acil tahsilatları üste alın.', imageUrl: null},
      {order: 5, text: '"Excel\'e Aktar" ile veriyi finansal takip dosyasına aktarın.', imageUrl: null},
    ],
    notes: [
      'Vade tarihi geçmiş faturaları bulmak için vade tarihi sütununa bugünden önceki tarihleri filtreleyin; gecikmiş alacaklarınızı hızlıca tespit edebilirsiniz.',
    ],
  },
  {
    id: 'report-expense-with-balance',
    category: 'Raporlar',
    title: 'Bakiyeli Gider Faturaları Raporu',
    summary: 'Ödemesi tamamlanmamış bakiyesi olan gider faturalarını tedarikçi ve vade bazında pivot tabloda görüntüleme.',
    tags: ['gider', 'bakiye', 'ödeme', 'borç', 'fatura', 'dinamik rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Bakiyeli Gider Faturaları" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Bakiyesi olan tüm gider faturaları otomatik yüklenir.', imageUrl: null},
      {order: 3, text: 'Tedarikçi bazında gruplamak için tedarikçi sütununu satır alanına sürükleyin.', imageUrl: null},
      {order: 4, text: '"Excel\'e Aktar" ile veriyi dışa aktarın.', imageUrl: null},
    ],
    notes: [
      'Bu raporu Gider Faturası Ödeme Planı raporu ile birlikte kullanın: önce bakiyeleri görün, sonra ödeme planlarını kontrol ederek nakit çıkışını planlayın.',
    ],
  },
  {
    id: 'report-checks-expense',
    category: 'Raporlar',
    title: 'Çek - Gider Faturası Eşleşme Raporu',
    summary: 'Gider faturalarına bağlı verilen çekleri çek numarası, vade tarihi, durum ve fatura bilgileriyle birlikte pivot tabloda görüntüleme.',
    tags: ['çek', 'gider', 'fatura', 'vade', 'eşleşme', 'durum', 'dinamik rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Çek - Gider Faturası Eşleşme" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Tüm eşleşmiş çek ve fatura kayıtları otomatik yüklenir.', imageUrl: null},
      {order: 3, text: 'Banka veya şirket bazında gruplamak için ilgili sütunu satır alanına sürükleyin.', imageUrl: null},
      {order: 4, text: 'Çek durumu sütununa filtre uygulayarak yalnızca belirli durumdaki çekleri (ör. Ödenecek, Ödendi) listeleyin.', imageUrl: null},
      {order: 5, text: '"Excel\'e Aktar" ile veriyi dışa aktarın.', imageUrl: null},
    ],
    notes: [
      'Vadesi yaklaşan çekleri görmek için vade tarihi sütununu artan sırayla sıralayın. Çek durumu "Ödenecek" ve vadesi yakın olanlar öncelikli takip gerektirir.',
    ],
  },
  {
    id: 'report-credit',
    category: 'Raporlar',
    title: 'Kredi Raporları (Açık ve Kapanan)',
    summary: 'Aktif banka kredilerini ve kapanmış kredileri hesap, proje, taksit ve vade bilgileriyle pivot tabloda görüntüleme.',
    tags: ['kredi', 'banka', 'hesap', 'taksit', 'vade', 'dinamik rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Açık Krediler" veya "Kapanan Krediler" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Krediler filtre gerektirmeden otomatik yüklenir.', imageUrl: null},
      {order: 3, text: 'Proje veya banka bazında gruplamak için ilgili sütunu satır alanına sürükleyin.', imageUrl: null},
      {order: 4, text: 'Vadesi yaklaşan kredileri önce görmek için vade tarihi sütununu artan sıraya göre sıralayın.', imageUrl: null},
      {order: 5, text: '"Excel\'e Aktar" ile veriyi dışa aktarın.', imageUrl: null},
    ],
    notes: [
      'Açık Krediler raporunu düzenli takip ederek bir sonraki taksit tarihini ve tutarını nakit akışı planlamanıza dahil edin.',
    ],
  },
  {
    id: 'report-task-completion',
    category: 'Raporlar',
    title: 'Görev Tamamlanma Oranı Raporları',
    summary: 'Proje, inşaat alanı veya parsel bazında iş programı görevlerinin tamamlanma yüzdelerini pivot tabloda görüntüleme.',
    tags: ['görev', 'tamamlanma', 'oran', 'proje', 'inşaat alanı', 'parsel', 'dinamik rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '— Proje Bazlı — "Dinamik Raporlar" → "Proje Bazlı Görev Tamamlanma Oranı" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Projeyi seçin ve "Getir" butonuna tıklayın. Pivot tabloda kök görev ve alt görev tamamlanma oranlarını inceleyin.', imageUrl: null},
      {order: 3, text: '— İnşaat Alanı Bazlı — "Dinamik Raporlar" → "İnşaat Alanı Bazlı Görev Tamamlanma Oranı" raporuna tıklayın.', imageUrl: null},
      {order: 4, text: 'Projeyi seçin, ardından inşaat alanını seçin ve "Getir" butonuna tıklayın.', imageUrl: null},
      {order: 5, text: '— İnşaat Alanı + Parsel Bazlı — "Dinamik Raporlar" → "İnşaat Alanı Bazlı Görev ve Parsel Tamamlanma Oranı" raporuna tıklayın.', imageUrl: null},
      {order: 6, text: 'Projeyi ve inşaat alanını seçin, "Getir" butonuna tıklayın. Pivot tabloda görev × parsel matrisini inceleyerek birim bazında ilerlemeyi takip edin.', imageUrl: null},
    ],
    notes: [
      'Proje bazlı raporu genel durum için, inşaat alanı bazlı raporu saha toplantılarında sunum için, parsel bazlı raporu daire/birim teslim takibi için kullanın.',
    ],
  },
  {
    id: 'report-monthly-payroll',
    category: 'Raporlar',
    title: 'Aylık Puantaj Raporu',
    summary: 'Seçilen projedeki personelin aylık çalışma günü, mesai, tatil ve avans bilgilerini pivot tabloda görüntüleme.',
    tags: ['puantaj', 'personel', 'çalışma günü', 'mesai', 'avans', 'proje', 'dinamik rapor'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Aylık Puantaj" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Projeyi listeden seçin (zorunlu) ve "Getir" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Pivot tabloda personel bazında çalışma verilerini inceleyin.', imageUrl: null},
      {order: 4, text: 'Personel adını satır alanına sürükleyerek kişi bazlı özet elde edin.', imageUrl: null},
      {order: 5, text: '"Excel\'e Aktar" ile muhasebe veya bordro sistemine aktarın.', imageUrl: null},
    ],
    notes: [
      'Verinin doğru olması için saha sorumlusunun aylık puantaj girişlerini tamamlamış olması gerekir. Eksik girişler bu raporda boş satır olarak görünür.',
    ],
  },
  {
    id: 'report-task-product',
    category: 'Raporlar',
    title: 'Proje Bazlı Malzeme Kullanım Raporu',
    summary: 'Seçilen projedeki iş programı görevlerine bağlı malzeme kullanımını ürün, miktar ve görev bazında pivot tabloda görüntüleme.',
    tags: ['malzeme', 'ürün', 'kullanım', 'görev', 'proje', 'miktar', 'dinamik rapor', 'stok'],
    thumbnailUrl: null,
    steps: [
      {order: 1, text: '"Raporlar" → "Dinamik Raporlar" → "Proje Bazlı Malzeme Kullanımı" raporuna tıklayın.', imageUrl: null},
      {order: 2, text: 'Projeyi listeden seçin (zorunlu) ve "Getir" butonuna tıklayın.', imageUrl: null},
      {order: 3, text: 'Pivot tabloda ürün adını satır alanına sürükleyerek ürün bazında toplam kullanım miktarını özetleyin.', imageUrl: null},
      {order: 4, text: 'Görev adına göre gruplayarak hangi görevin en fazla malzeme tükettiğini görün.', imageUrl: null},
      {order: 5, text: '"Excel\'e Aktar" ile veriyi tedarik planlamasına aktarın.', imageUrl: null},
    ],
    notes: [
      'Bu raporu düzenli çalıştırarak planlanan ve gerçekleşen malzeme miktarlarını karşılaştırın. Aşırı tüketim gösteren kalemleri tespit ederek tedarik planınızı güncelleyebilirsiniz.',
    ],
  },
]
